const animationData = {
    v: '4.8.0',
    ip: 0,
    op: 138,
    fr: 30,
    w: 1080,
    h: 1080,
    nm: 'E',
    assets: [
        {
            id: 'comp_0',
            layers: [
                {
                    ind: 1,
                    ty: 4,
                    nm: 'm',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            a: 0,
                            k: [554.622, 539.93, 0],
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-4.195, -2.337],
                                                [0, 0],
                                                [-24.51, 39.427],
                                                [42.492, 24.512],
                                                [0, 0],
                                                [-4.495, -1.737],
                                                [0, 0],
                                                [-0.547, -0.189],
                                                [-7.162, 0],
                                                [-2.315, 30.747],
                                                [36.381, 0],
                                                [0, 0],
                                                [-0.394, -35.661],
                                                [-13.292, -11.581],
                                                [-16.07, -12.883],
                                                [3.656, 0],
                                                [0, 0],
                                                [0, -59.008],
                                                [-22.355, -19.6],
                                                [0, 0],
                                                [-37.22, 1.102],
                                                [-0.195, 68.745],
                                                [32.277, 23.374],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.805, -2.909],
                                                [0, 0],
                                                [40.516, 22.718],
                                                [25.859, -41.597],
                                                [0, 0],
                                                [-4.135, -2.428],
                                                [0, 0],
                                                [0, 0],
                                                [6.411, 2.215],
                                                [32.694, 0],
                                                [2.997, -39.795],
                                                [-17.828, 0],
                                                [-35.751, 0],
                                                [0.21, 18.97],
                                                [10.009, 8.721],
                                                [2.877, 2.306],
                                                [0, 0],
                                                [-59.065, 0],
                                                [0, 32.064],
                                                [0, 0],
                                                [24.095, 24.334],
                                                [68.775, -2.037],
                                                [0.121, -42.852],
                                                [0, 0],
                                            ],
                                            v: [
                                                [232.124, 113.596],
                                                [232.215, 113.596],
                                                [162.932, 58.397],
                                                [8.239, -60.662],
                                                [12.526, -67.107],
                                                [101.917, -17.062],
                                                [218.192, -46.907],
                                                [187.895, -167.795],
                                                [56.698, -243.61],
                                                [60.085, -250.594],
                                                [120.349, -226.472],
                                                [122.446, -225.691],
                                                [142.884, -222.247],
                                                [204.733, -278.853],
                                                [140.904, -346.46],
                                                [-137.698, -346.491],
                                                [-203.026, -281.581],
                                                [-181.001, -234.082],
                                                [-121.127, -185.475],
                                                [-123.554, -178.582],
                                                [-178.664, -178.582],
                                                [-285.346, -71.48],
                                                [-249.116, 8.592],
                                                [65.718, 307.693],
                                                [160.804, 345.66],
                                                [285.256, 217.85],
                                                [232.094, 113.627],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'fl',
                                    nm: 'F',
                                    bm: 0,
                                    c: {
                                        a: 0,
                                        k: [
                                            0.133333333333, 0.113725490196,
                                            0.098039215686, 1,
                                        ],
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                        {
                            ty: 'op',
                            nm: 'O',
                            ml: {
                                a: 0,
                                k: 4,
                            },
                            a: {
                                a: 0,
                                k: 0,
                            },
                            lj: 1,
                        },
                    ],
                    ip: 51,
                    op: 117,
                    st: -58,
                    td: 1,
                },
                {
                    ind: 2,
                    ty: 4,
                    nm: 'L',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            k: [
                                {
                                    i: {
                                        x: 0,
                                        y: 1,
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0,
                                    },
                                    t: 51,
                                    s: [923, 946, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833,
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0.333,
                                    },
                                    t: 75,
                                    s: [553, 622, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833,
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167,
                                    },
                                    t: 106,
                                    s: [553, 622, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    t: 109,
                                    s: [821, 864, 0],
                                },
                            ],
                            a: 1,
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            k: [
                                {
                                    i: {
                                        x: [0, 0, 0.667],
                                        y: [1, 1, 1],
                                    },
                                    o: {
                                        x: [0.333, 0.333, 0.333],
                                        y: [0, 0, 0],
                                    },
                                    t: 51,
                                    s: [119, 119, 100],
                                },
                                {
                                    t: 75,
                                    s: [100, 100, 100],
                                },
                            ],
                            a: 1,
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [33.096, 24.089],
                                                [2.91, 2.117],
                                                [2.91, 2.116],
                                                [2.91, 2.116],
                                                [2.911, 2.115],
                                                [2.911, 2.115],
                                                [2.912, 2.115],
                                                [2.912, 2.114],
                                                [2.912, 2.114],
                                                [2.912, 2.113],
                                                [2.913, 2.112],
                                                [2.914, 2.112],
                                                [2.913, 2.111],
                                                [2.914, 2.111],
                                                [2.915, 2.11],
                                                [2.915, 2.11],
                                                [2.916, 2.109],
                                                [2.918, 2.11],
                                                [2.918, 2.109],
                                                [2.919, 2.108],
                                                [2.92, 2.108],
                                                [2.92, 2.107],
                                                [2.921, 2.106],
                                                [2.922, 2.106],
                                                [2.922, 2.104],
                                                [2.923, 2.104],
                                                [2.923, 2.103],
                                                [2.924, 2.102],
                                                [2.925, 2.102],
                                                [2.925, 2.101],
                                                [2.926, 2.1],
                                                [2.926, 2.099],
                                                [2.927, 2.098],
                                                [2.928, 2.097],
                                                [2.928, 2.097],
                                                [2.929, 2.096],
                                                [2.93, 2.095],
                                                [2.931, 2.094],
                                                [2.931, 2.093],
                                                [2.932, 2.092],
                                                [2.932, 2.091],
                                                [27.214, 0],
                                                [0, -59.647],
                                                [-22.064, -19.774],
                                                [-2.679, -2.402],
                                                [-2.678, -2.403],
                                                [-2.677, -2.403],
                                                [-2.677, -2.404],
                                                [-2.676, -2.404],
                                                [-2.676, -2.405],
                                                [-2.676, -2.406],
                                                [-2.675, -2.406],
                                                [-2.674, -2.407],
                                                [-2.674, -2.407],
                                                [-2.673, -2.408],
                                                [-2.673, -2.408],
                                                [-2.672, -2.409],
                                                [-2.671, -2.409],
                                                [-2.671, -2.41],
                                                [-2.671, -2.41],
                                                [-2.67, -2.411],
                                                [-2.67, -2.411],
                                                [-2.669, -2.412],
                                                [-2.669, -2.412],
                                                [-2.668, -2.413],
                                                [-2.668, -2.413],
                                                [-2.667, -2.414],
                                                [-2.667, -2.414],
                                                [-2.666, -2.415],
                                                [-2.666, -2.415],
                                                [-2.665, -2.416],
                                                [-2.665, -2.416],
                                                [-2.665, -2.417],
                                                [-2.664, -2.417],
                                                [-2.664, -2.417],
                                                [-2.663, -2.418],
                                                [-2.663, -2.418],
                                                [-2.662, -2.419],
                                                [-2.662, -2.419],
                                                [-2.66, -2.419],
                                                [-2.659, -2.419],
                                                [-2.659, -2.419],
                                                [-2.658, -2.42],
                                                [-2.657, -2.42],
                                                [-38.239, 0],
                                                [0, 73.178],
                                            ],
                                            o: [
                                                [-2.723, -2.342],
                                                [-2.722, -2.343],
                                                [-2.722, -2.343],
                                                [-2.721, -2.344],
                                                [-2.721, -2.344],
                                                [-2.72, -2.345],
                                                [-2.72, -2.345],
                                                [-2.72, -2.346],
                                                [-2.719, -2.346],
                                                [-2.718, -2.347],
                                                [-2.718, -2.348],
                                                [-2.717, -2.348],
                                                [-2.717, -2.349],
                                                [-2.716, -2.35],
                                                [-2.715, -2.35],
                                                [-2.716, -2.351],
                                                [-2.716, -2.353],
                                                [-2.716, -2.354],
                                                [-2.716, -2.354],
                                                [-2.715, -2.355],
                                                [-2.715, -2.355],
                                                [-2.714, -2.356],
                                                [-2.714, -2.356],
                                                [-2.713, -2.356],
                                                [-2.713, -2.357],
                                                [-2.713, -2.358],
                                                [-2.712, -2.358],
                                                [-2.712, -2.359],
                                                [-2.711, -2.359],
                                                [-2.711, -2.36],
                                                [-2.71, -2.36],
                                                [-2.71, -2.361],
                                                [-2.709, -2.361],
                                                [-2.709, -2.362],
                                                [-2.708, -2.362],
                                                [-2.708, -2.363],
                                                [-2.707, -2.364],
                                                [-2.707, -2.364],
                                                [-2.706, -2.365],
                                                [-2.706, -2.365],
                                                [-18.992, -16.611],
                                                [-59.647, 0],
                                                [0, 31.96],
                                                [2.429, 2.654],
                                                [2.43, 2.653],
                                                [2.43, 2.652],
                                                [2.431, 2.652],
                                                [2.432, 2.651],
                                                [2.433, 2.65],
                                                [2.434, 2.65],
                                                [2.434, 2.649],
                                                [2.435, 2.648],
                                                [2.435, 2.647],
                                                [2.436, 2.647],
                                                [2.437, 2.646],
                                                [2.438, 2.645],
                                                [2.438, 2.644],
                                                [2.439, 2.644],
                                                [2.44, 2.643],
                                                [2.44, 2.643],
                                                [2.441, 2.642],
                                                [2.442, 2.641],
                                                [2.443, 2.641],
                                                [2.443, 2.64],
                                                [2.444, 2.64],
                                                [2.444, 2.639],
                                                [2.445, 2.638],
                                                [2.446, 2.638],
                                                [2.446, 2.637],
                                                [2.447, 2.636],
                                                [2.448, 2.636],
                                                [2.448, 2.635],
                                                [2.449, 2.635],
                                                [2.449, 2.634],
                                                [2.45, 2.634],
                                                [2.451, 2.633],
                                                [2.451, 2.632],
                                                [2.452, 2.632],
                                                [2.451, 2.63],
                                                [2.451, 2.629],
                                                [2.452, 2.629],
                                                [2.452, 2.629],
                                                [2.452, 2.628],
                                                [24.185, 25.91],
                                                [73.178, 0],
                                                [0, -44.067],
                                            ],
                                            v: [
                                                [231.386, 27.309],
                                                [222.931, 20.62],
                                                [214.477, 13.932],
                                                [206.022, 7.244],
                                                [197.568, 0.556],
                                                [189.113, -6.132],
                                                [180.658, -12.821],
                                                [172.204, -19.509],
                                                [163.749, -26.197],
                                                [155.295, -32.885],
                                                [146.841, -39.573],
                                                [138.386, -46.262],
                                                [129.932, -52.949],
                                                [121.477, -59.638],
                                                [113.022, -66.326],
                                                [104.569, -73.014],
                                                [96.113, -79.703],
                                                [87.653, -86.395],
                                                [79.193, -93.087],
                                                [70.733, -99.779],
                                                [62.272, -106.472],
                                                [53.812, -113.164],
                                                [45.352, -119.857],
                                                [36.891, -126.549],
                                                [28.431, -133.241],
                                                [19.971, -139.934],
                                                [11.51, -146.626],
                                                [3.05, -153.319],
                                                [-5.41, -160.011],
                                                [-13.871, -166.703],
                                                [-22.331, -173.396],
                                                [-30.791, -180.088],
                                                [-39.251, -186.78],
                                                [-47.712, -193.473],
                                                [-56.172, -200.165],
                                                [-64.632, -206.858],
                                                [-73.092, -213.55],
                                                [-81.553, -220.242],
                                                [-90.013, -226.935],
                                                [-98.474, -233.627],
                                                [-106.934, -240.319],
                                                [-178, -267],
                                                [-286, -159],
                                                [-250.049, -78.552],
                                                [-242.381, -70.966],
                                                [-234.713, -63.379],
                                                [-227.046, -55.793],
                                                [-219.378, -48.206],
                                                [-211.711, -40.62],
                                                [-204.044, -33.033],
                                                [-196.376, -25.446],
                                                [-188.709, -17.86],
                                                [-181.041, -10.273],
                                                [-173.374, -2.687],
                                                [-165.706, 4.9],
                                                [-158.039, 12.487],
                                                [-150.371, 20.073],
                                                [-142.704, 27.659],
                                                [-135.036, 35.247],
                                                [-127.369, 42.833],
                                                [-119.701, 50.419],
                                                [-112.034, 58.006],
                                                [-104.367, 65.592],
                                                [-96.699, 73.179],
                                                [-89.032, 80.766],
                                                [-81.364, 88.352],
                                                [-73.697, 95.939],
                                                [-66.029, 103.526],
                                                [-58.361, 111.112],
                                                [-50.694, 118.698],
                                                [-43.027, 126.285],
                                                [-35.359, 133.872],
                                                [-27.692, 141.458],
                                                [-20.024, 149.045],
                                                [-12.357, 156.631],
                                                [-4.689, 164.218],
                                                [2.979, 171.805],
                                                [10.646, 179.391],
                                                [18.313, 186.978],
                                                [25.977, 194.561],
                                                [33.64, 202.142],
                                                [41.302, 209.723],
                                                [48.965, 217.305],
                                                [56.627, 224.886],
                                                [153.5, 267],
                                                [286, 134.5],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'gf',
                                    s: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 78,
                                                s: [-201.545, -178.118],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 103,
                                                s: [-239.062, -217.595],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 109,
                                                s: [-397.757, -345.658],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    e: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 78,
                                                s: [178.631, 158.89],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 103,
                                                s: [129.303, 113.572],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 109,
                                                s: [-85.025, -81.343],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    t: 1,
                                    g: {
                                        k: {
                                            a: 0,
                                            k: [
                                                0, 1, 0.757, 0.925, 0.499, 0.71,
                                                0.639, 0.961, 0.997, 0.42,
                                                0.522, 0.996,
                                            ],
                                        },
                                        p: 3,
                                    },
                                    nm: 'G',
                                    bm: 0,
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                    ],
                    ip: 51,
                    op: 117,
                    st: 47,
                    tt: 1,
                },
                {
                    ind: 3,
                    ty: 4,
                    nm: 'm',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            a: 0,
                            k: [554.622, 539.93, 0],
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-4.195, -2.337],
                                                [0, 0],
                                                [-24.51, 39.427],
                                                [42.492, 24.512],
                                                [0, 0],
                                                [-4.495, -1.737],
                                                [0, 0],
                                                [-0.547, -0.189],
                                                [-7.162, 0],
                                                [-2.315, 30.747],
                                                [36.381, 0],
                                                [0, 0],
                                                [-0.394, -35.661],
                                                [-13.292, -11.581],
                                                [-16.07, -12.883],
                                                [3.656, 0],
                                                [0, 0],
                                                [0, -59.008],
                                                [-22.355, -19.6],
                                                [0, 0],
                                                [-37.22, 1.102],
                                                [-0.195, 68.745],
                                                [32.277, 23.374],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.805, -2.909],
                                                [0, 0],
                                                [40.516, 22.718],
                                                [25.859, -41.597],
                                                [0, 0],
                                                [-4.135, -2.428],
                                                [0, 0],
                                                [0, 0],
                                                [6.411, 2.215],
                                                [32.694, 0],
                                                [2.997, -39.795],
                                                [-17.828, 0],
                                                [-35.751, 0],
                                                [0.21, 18.97],
                                                [10.009, 8.721],
                                                [2.877, 2.306],
                                                [0, 0],
                                                [-59.065, 0],
                                                [0, 32.064],
                                                [0, 0],
                                                [24.095, 24.334],
                                                [68.775, -2.037],
                                                [0.121, -42.852],
                                                [0, 0],
                                            ],
                                            v: [
                                                [232.124, 113.596],
                                                [232.215, 113.596],
                                                [162.932, 58.397],
                                                [8.239, -60.662],
                                                [12.526, -67.107],
                                                [101.917, -17.062],
                                                [218.192, -46.907],
                                                [187.895, -167.795],
                                                [56.698, -243.61],
                                                [60.085, -250.594],
                                                [120.349, -226.472],
                                                [122.446, -225.691],
                                                [142.884, -222.247],
                                                [204.733, -278.853],
                                                [140.904, -346.46],
                                                [-137.698, -346.491],
                                                [-203.026, -281.581],
                                                [-181.001, -234.082],
                                                [-121.127, -185.475],
                                                [-123.554, -178.582],
                                                [-178.664, -178.582],
                                                [-285.346, -71.48],
                                                [-249.116, 8.592],
                                                [65.718, 307.693],
                                                [160.804, 345.66],
                                                [285.256, 217.85],
                                                [232.094, 113.627],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'fl',
                                    nm: 'F',
                                    bm: 0,
                                    c: {
                                        a: 0,
                                        k: [
                                            0.133333333333, 0.113725490196,
                                            0.098039215686, 1,
                                        ],
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                        {
                            ty: 'op',
                            nm: 'O',
                            ml: {
                                a: 0,
                                k: 4,
                            },
                            a: {
                                a: 0,
                                k: 0,
                            },
                            lj: 1,
                        },
                    ],
                    ip: 35,
                    op: 71,
                    st: -72,
                    td: 1,
                },
                {
                    ind: 4,
                    ty: 4,
                    nm: 's',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            k: [
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833,
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167,
                                    },
                                    t: 33,
                                    s: [923, 946, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    t: 49,
                                    s: [553, 624, 0],
                                },
                            ],
                            a: 1,
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            k: [
                                {
                                    i: {
                                        x: [0.833, 0.833, 0.833],
                                        y: [0.833, 0.833, 0.833],
                                    },
                                    o: {
                                        x: [0.167, 0.167, 0.167],
                                        y: [0.167, 0.167, 0.167],
                                    },
                                    t: 33,
                                    s: [119, 119, 100],
                                },
                                {
                                    t: 49,
                                    s: [100, 100, 100],
                                },
                            ],
                            a: 1,
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [33.096, 24.089],
                                                [2.91, 2.117],
                                                [2.91, 2.116],
                                                [2.91, 2.116],
                                                [2.911, 2.115],
                                                [2.911, 2.115],
                                                [2.912, 2.115],
                                                [2.912, 2.114],
                                                [2.912, 2.114],
                                                [2.912, 2.113],
                                                [2.913, 2.112],
                                                [2.914, 2.112],
                                                [2.913, 2.111],
                                                [2.914, 2.111],
                                                [2.915, 2.11],
                                                [2.915, 2.11],
                                                [2.916, 2.109],
                                                [2.918, 2.11],
                                                [2.918, 2.109],
                                                [2.919, 2.108],
                                                [2.92, 2.108],
                                                [2.92, 2.107],
                                                [2.921, 2.106],
                                                [2.922, 2.106],
                                                [2.922, 2.104],
                                                [2.923, 2.104],
                                                [2.923, 2.103],
                                                [2.924, 2.102],
                                                [2.925, 2.102],
                                                [2.925, 2.101],
                                                [2.926, 2.1],
                                                [2.926, 2.099],
                                                [2.927, 2.098],
                                                [2.928, 2.097],
                                                [2.928, 2.097],
                                                [2.929, 2.096],
                                                [2.93, 2.095],
                                                [2.931, 2.094],
                                                [2.931, 2.093],
                                                [2.932, 2.092],
                                                [2.932, 2.091],
                                                [27.214, 0],
                                                [0, -59.647],
                                                [-22.064, -19.774],
                                                [-2.679, -2.402],
                                                [-2.678, -2.403],
                                                [-2.677, -2.403],
                                                [-2.677, -2.404],
                                                [-2.676, -2.404],
                                                [-2.676, -2.405],
                                                [-2.676, -2.406],
                                                [-2.675, -2.406],
                                                [-2.674, -2.407],
                                                [-2.674, -2.407],
                                                [-2.673, -2.408],
                                                [-2.673, -2.408],
                                                [-2.672, -2.409],
                                                [-2.671, -2.409],
                                                [-2.671, -2.41],
                                                [-2.671, -2.41],
                                                [-2.67, -2.411],
                                                [-2.67, -2.411],
                                                [-2.669, -2.412],
                                                [-2.669, -2.412],
                                                [-2.668, -2.413],
                                                [-2.668, -2.413],
                                                [-2.667, -2.414],
                                                [-2.667, -2.414],
                                                [-2.666, -2.415],
                                                [-2.666, -2.415],
                                                [-2.665, -2.416],
                                                [-2.665, -2.416],
                                                [-2.665, -2.417],
                                                [-2.664, -2.417],
                                                [-2.664, -2.417],
                                                [-2.663, -2.418],
                                                [-2.663, -2.418],
                                                [-2.662, -2.419],
                                                [-2.662, -2.419],
                                                [-2.66, -2.419],
                                                [-2.659, -2.419],
                                                [-2.659, -2.419],
                                                [-2.658, -2.42],
                                                [-2.657, -2.42],
                                                [-38.239, 0],
                                                [0, 73.178],
                                            ],
                                            o: [
                                                [-2.723, -2.342],
                                                [-2.722, -2.343],
                                                [-2.722, -2.343],
                                                [-2.721, -2.344],
                                                [-2.721, -2.344],
                                                [-2.72, -2.345],
                                                [-2.72, -2.345],
                                                [-2.72, -2.346],
                                                [-2.719, -2.346],
                                                [-2.718, -2.347],
                                                [-2.718, -2.348],
                                                [-2.717, -2.348],
                                                [-2.717, -2.349],
                                                [-2.716, -2.35],
                                                [-2.715, -2.35],
                                                [-2.716, -2.351],
                                                [-2.716, -2.353],
                                                [-2.716, -2.354],
                                                [-2.716, -2.354],
                                                [-2.715, -2.355],
                                                [-2.715, -2.355],
                                                [-2.714, -2.356],
                                                [-2.714, -2.356],
                                                [-2.713, -2.356],
                                                [-2.713, -2.357],
                                                [-2.713, -2.358],
                                                [-2.712, -2.358],
                                                [-2.712, -2.359],
                                                [-2.711, -2.359],
                                                [-2.711, -2.36],
                                                [-2.71, -2.36],
                                                [-2.71, -2.361],
                                                [-2.709, -2.361],
                                                [-2.709, -2.362],
                                                [-2.708, -2.362],
                                                [-2.708, -2.363],
                                                [-2.707, -2.364],
                                                [-2.707, -2.364],
                                                [-2.706, -2.365],
                                                [-2.706, -2.365],
                                                [-18.992, -16.611],
                                                [-59.647, 0],
                                                [0, 31.96],
                                                [2.429, 2.654],
                                                [2.43, 2.653],
                                                [2.43, 2.652],
                                                [2.431, 2.652],
                                                [2.432, 2.651],
                                                [2.433, 2.65],
                                                [2.434, 2.65],
                                                [2.434, 2.649],
                                                [2.435, 2.648],
                                                [2.435, 2.647],
                                                [2.436, 2.647],
                                                [2.437, 2.646],
                                                [2.438, 2.645],
                                                [2.438, 2.644],
                                                [2.439, 2.644],
                                                [2.44, 2.643],
                                                [2.44, 2.643],
                                                [2.441, 2.642],
                                                [2.442, 2.641],
                                                [2.443, 2.641],
                                                [2.443, 2.64],
                                                [2.444, 2.64],
                                                [2.444, 2.639],
                                                [2.445, 2.638],
                                                [2.446, 2.638],
                                                [2.446, 2.637],
                                                [2.447, 2.636],
                                                [2.448, 2.636],
                                                [2.448, 2.635],
                                                [2.449, 2.635],
                                                [2.449, 2.634],
                                                [2.45, 2.634],
                                                [2.451, 2.633],
                                                [2.451, 2.632],
                                                [2.452, 2.632],
                                                [2.451, 2.63],
                                                [2.451, 2.629],
                                                [2.452, 2.629],
                                                [2.452, 2.629],
                                                [2.452, 2.628],
                                                [24.185, 25.91],
                                                [73.178, 0],
                                                [0, -44.067],
                                            ],
                                            v: [
                                                [231.386, 27.309],
                                                [222.931, 20.62],
                                                [214.477, 13.932],
                                                [206.022, 7.244],
                                                [197.568, 0.556],
                                                [189.113, -6.132],
                                                [180.658, -12.821],
                                                [172.204, -19.509],
                                                [163.749, -26.197],
                                                [155.295, -32.885],
                                                [146.841, -39.573],
                                                [138.386, -46.262],
                                                [129.932, -52.949],
                                                [121.477, -59.638],
                                                [113.022, -66.326],
                                                [104.569, -73.014],
                                                [96.113, -79.703],
                                                [87.653, -86.395],
                                                [79.193, -93.087],
                                                [70.733, -99.779],
                                                [62.272, -106.472],
                                                [53.812, -113.164],
                                                [45.352, -119.857],
                                                [36.891, -126.549],
                                                [28.431, -133.241],
                                                [19.971, -139.934],
                                                [11.51, -146.626],
                                                [3.05, -153.319],
                                                [-5.41, -160.011],
                                                [-13.871, -166.703],
                                                [-22.331, -173.396],
                                                [-30.791, -180.088],
                                                [-39.251, -186.78],
                                                [-47.712, -193.473],
                                                [-56.172, -200.165],
                                                [-64.632, -206.858],
                                                [-73.092, -213.55],
                                                [-81.553, -220.242],
                                                [-90.013, -226.935],
                                                [-98.474, -233.627],
                                                [-106.934, -240.319],
                                                [-178, -267],
                                                [-286, -159],
                                                [-250.049, -78.552],
                                                [-242.381, -70.966],
                                                [-234.713, -63.379],
                                                [-227.046, -55.793],
                                                [-219.378, -48.206],
                                                [-211.711, -40.62],
                                                [-204.044, -33.033],
                                                [-196.376, -25.446],
                                                [-188.709, -17.86],
                                                [-181.041, -10.273],
                                                [-173.374, -2.687],
                                                [-165.706, 4.9],
                                                [-158.039, 12.487],
                                                [-150.371, 20.073],
                                                [-142.704, 27.659],
                                                [-135.036, 35.247],
                                                [-127.369, 42.833],
                                                [-119.701, 50.419],
                                                [-112.034, 58.006],
                                                [-104.367, 65.592],
                                                [-96.699, 73.179],
                                                [-89.032, 80.766],
                                                [-81.364, 88.352],
                                                [-73.697, 95.939],
                                                [-66.029, 103.526],
                                                [-58.361, 111.112],
                                                [-50.694, 118.698],
                                                [-43.027, 126.285],
                                                [-35.359, 133.872],
                                                [-27.692, 141.458],
                                                [-20.024, 149.045],
                                                [-12.357, 156.631],
                                                [-4.689, 164.218],
                                                [2.979, 171.805],
                                                [10.646, 179.391],
                                                [18.313, 186.978],
                                                [25.977, 194.561],
                                                [33.64, 202.142],
                                                [41.302, 209.723],
                                                [48.965, 217.305],
                                                [56.627, 224.886],
                                                [153.5, 267],
                                                [286, 134.5],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'gf',
                                    s: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 47,
                                                s: [-125.833, -104.801],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 65,
                                                s: [-539.194, -533.408],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    e: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 47,
                                                s: [-26.009, -24.043],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 65,
                                                s: [-158.33, -151.641],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    t: 1,
                                    g: {
                                        k: {
                                            a: 0,
                                            k: [
                                                0, 0.808, 1, 0.345, 0.5, 0.904,
                                                0.878, 0.635, 1, 1, 0.757,
                                                0.925,
                                            ],
                                        },
                                        p: 3,
                                    },
                                    nm: 'G',
                                    bm: 0,
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                    ],
                    ip: 35,
                    op: 71,
                    st: 16,
                    tt: 1,
                },
                {
                    ind: 5,
                    ty: 4,
                    nm: 'm',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            a: 0,
                            k: [554.622, 539.93, 0],
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-4.195, -2.337],
                                                [0, 0],
                                                [-24.51, 39.427],
                                                [42.492, 24.512],
                                                [0, 0],
                                                [-4.495, -1.737],
                                                [0, 0],
                                                [-0.547, -0.189],
                                                [-7.162, 0],
                                                [-2.315, 30.747],
                                                [36.381, 0],
                                                [0, 0],
                                                [-0.394, -35.661],
                                                [-13.292, -11.581],
                                                [-16.07, -12.883],
                                                [3.656, 0],
                                                [0, 0],
                                                [0, -59.008],
                                                [-22.355, -19.6],
                                                [0, 0],
                                                [-37.22, 1.102],
                                                [-0.195, 68.745],
                                                [32.277, 23.374],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.805, -2.909],
                                                [0, 0],
                                                [40.516, 22.718],
                                                [25.859, -41.597],
                                                [0, 0],
                                                [-4.135, -2.428],
                                                [0, 0],
                                                [0, 0],
                                                [6.411, 2.215],
                                                [32.694, 0],
                                                [2.997, -39.795],
                                                [-17.828, 0],
                                                [-35.751, 0],
                                                [0.21, 18.97],
                                                [10.009, 8.721],
                                                [2.877, 2.306],
                                                [0, 0],
                                                [-59.065, 0],
                                                [0, 32.064],
                                                [0, 0],
                                                [24.095, 24.334],
                                                [68.775, -2.037],
                                                [0.121, -42.852],
                                                [0, 0],
                                            ],
                                            v: [
                                                [232.124, 113.596],
                                                [232.215, 113.596],
                                                [162.932, 58.397],
                                                [8.239, -60.662],
                                                [12.526, -67.107],
                                                [101.917, -17.062],
                                                [218.192, -46.907],
                                                [187.895, -167.795],
                                                [56.698, -243.61],
                                                [60.085, -250.594],
                                                [120.349, -226.472],
                                                [122.446, -225.691],
                                                [142.884, -222.247],
                                                [204.733, -278.853],
                                                [140.904, -346.46],
                                                [-137.698, -346.491],
                                                [-203.026, -281.581],
                                                [-181.001, -234.082],
                                                [-121.127, -185.475],
                                                [-123.554, -178.582],
                                                [-178.664, -178.582],
                                                [-285.346, -71.48],
                                                [-249.116, 8.592],
                                                [65.718, 307.693],
                                                [160.804, 345.66],
                                                [285.256, 217.85],
                                                [232.094, 113.627],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'fl',
                                    nm: 'F',
                                    bm: 0,
                                    c: {
                                        a: 0,
                                        k: [
                                            0.133333333333, 0.113725490196,
                                            0.098039215686, 1,
                                        ],
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                        {
                            ty: 'op',
                            nm: 'O',
                            ml: {
                                a: 0,
                                k: 4,
                            },
                            a: {
                                a: 0,
                                k: 0,
                            },
                            lj: 1,
                        },
                    ],
                    ip: 12,
                    op: 49,
                    st: -95,
                    td: 1,
                },
                {
                    ind: 6,
                    ty: 4,
                    nm: 's',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: -1,
                        },
                        p: {
                            k: [
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833,
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167,
                                    },
                                    t: 12,
                                    s: [941, 958, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    t: 24,
                                    s: [553, 624, 0],
                                },
                            ],
                            a: 1,
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            k: [
                                {
                                    i: {
                                        x: [0.833, 0.833, 0.833],
                                        y: [0.833, 0.833, 0.833],
                                    },
                                    o: {
                                        x: [0.167, 0.167, 0.167],
                                        y: [0.167, 0.167, 0.167],
                                    },
                                    t: 12,
                                    s: [123, 123, 100],
                                },
                                {
                                    t: 24,
                                    s: [100, 100, 100],
                                },
                            ],
                            a: 1,
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [33.096, 24.089],
                                                [2.91, 2.117],
                                                [2.91, 2.116],
                                                [2.91, 2.116],
                                                [2.911, 2.115],
                                                [2.911, 2.115],
                                                [2.912, 2.115],
                                                [2.912, 2.114],
                                                [2.912, 2.114],
                                                [2.912, 2.113],
                                                [2.913, 2.112],
                                                [2.914, 2.112],
                                                [2.913, 2.111],
                                                [2.914, 2.111],
                                                [2.915, 2.11],
                                                [2.915, 2.11],
                                                [2.916, 2.109],
                                                [2.918, 2.11],
                                                [2.918, 2.109],
                                                [2.919, 2.108],
                                                [2.92, 2.108],
                                                [2.92, 2.107],
                                                [2.921, 2.106],
                                                [2.922, 2.106],
                                                [2.922, 2.104],
                                                [2.923, 2.104],
                                                [2.923, 2.103],
                                                [2.924, 2.102],
                                                [2.925, 2.102],
                                                [2.925, 2.101],
                                                [2.926, 2.1],
                                                [2.926, 2.099],
                                                [2.927, 2.098],
                                                [2.928, 2.097],
                                                [2.928, 2.097],
                                                [2.929, 2.096],
                                                [2.93, 2.095],
                                                [2.931, 2.094],
                                                [2.931, 2.093],
                                                [2.932, 2.092],
                                                [2.932, 2.091],
                                                [27.214, 0],
                                                [0, -59.647],
                                                [-22.064, -19.774],
                                                [-2.679, -2.402],
                                                [-2.678, -2.403],
                                                [-2.677, -2.403],
                                                [-2.677, -2.404],
                                                [-2.676, -2.404],
                                                [-2.676, -2.405],
                                                [-2.676, -2.406],
                                                [-2.675, -2.406],
                                                [-2.674, -2.407],
                                                [-2.674, -2.407],
                                                [-2.673, -2.408],
                                                [-2.673, -2.408],
                                                [-2.672, -2.409],
                                                [-2.671, -2.409],
                                                [-2.671, -2.41],
                                                [-2.671, -2.41],
                                                [-2.67, -2.411],
                                                [-2.67, -2.411],
                                                [-2.669, -2.412],
                                                [-2.669, -2.412],
                                                [-2.668, -2.413],
                                                [-2.668, -2.413],
                                                [-2.667, -2.414],
                                                [-2.667, -2.414],
                                                [-2.666, -2.415],
                                                [-2.666, -2.415],
                                                [-2.665, -2.416],
                                                [-2.665, -2.416],
                                                [-2.665, -2.417],
                                                [-2.664, -2.417],
                                                [-2.664, -2.417],
                                                [-2.663, -2.418],
                                                [-2.663, -2.418],
                                                [-2.662, -2.419],
                                                [-2.662, -2.419],
                                                [-2.66, -2.419],
                                                [-2.659, -2.419],
                                                [-2.659, -2.419],
                                                [-2.658, -2.42],
                                                [-2.657, -2.42],
                                                [-38.239, 0],
                                                [0, 73.178],
                                            ],
                                            o: [
                                                [-2.723, -2.342],
                                                [-2.722, -2.343],
                                                [-2.722, -2.343],
                                                [-2.721, -2.344],
                                                [-2.721, -2.344],
                                                [-2.72, -2.345],
                                                [-2.72, -2.345],
                                                [-2.72, -2.346],
                                                [-2.719, -2.346],
                                                [-2.718, -2.347],
                                                [-2.718, -2.348],
                                                [-2.717, -2.348],
                                                [-2.717, -2.349],
                                                [-2.716, -2.35],
                                                [-2.715, -2.35],
                                                [-2.716, -2.351],
                                                [-2.716, -2.353],
                                                [-2.716, -2.354],
                                                [-2.716, -2.354],
                                                [-2.715, -2.355],
                                                [-2.715, -2.355],
                                                [-2.714, -2.356],
                                                [-2.714, -2.356],
                                                [-2.713, -2.356],
                                                [-2.713, -2.357],
                                                [-2.713, -2.358],
                                                [-2.712, -2.358],
                                                [-2.712, -2.359],
                                                [-2.711, -2.359],
                                                [-2.711, -2.36],
                                                [-2.71, -2.36],
                                                [-2.71, -2.361],
                                                [-2.709, -2.361],
                                                [-2.709, -2.362],
                                                [-2.708, -2.362],
                                                [-2.708, -2.363],
                                                [-2.707, -2.364],
                                                [-2.707, -2.364],
                                                [-2.706, -2.365],
                                                [-2.706, -2.365],
                                                [-18.992, -16.611],
                                                [-59.647, 0],
                                                [0, 31.96],
                                                [2.429, 2.654],
                                                [2.43, 2.653],
                                                [2.43, 2.652],
                                                [2.431, 2.652],
                                                [2.432, 2.651],
                                                [2.433, 2.65],
                                                [2.434, 2.65],
                                                [2.434, 2.649],
                                                [2.435, 2.648],
                                                [2.435, 2.647],
                                                [2.436, 2.647],
                                                [2.437, 2.646],
                                                [2.438, 2.645],
                                                [2.438, 2.644],
                                                [2.439, 2.644],
                                                [2.44, 2.643],
                                                [2.44, 2.643],
                                                [2.441, 2.642],
                                                [2.442, 2.641],
                                                [2.443, 2.641],
                                                [2.443, 2.64],
                                                [2.444, 2.64],
                                                [2.444, 2.639],
                                                [2.445, 2.638],
                                                [2.446, 2.638],
                                                [2.446, 2.637],
                                                [2.447, 2.636],
                                                [2.448, 2.636],
                                                [2.448, 2.635],
                                                [2.449, 2.635],
                                                [2.449, 2.634],
                                                [2.45, 2.634],
                                                [2.451, 2.633],
                                                [2.451, 2.632],
                                                [2.452, 2.632],
                                                [2.451, 2.63],
                                                [2.451, 2.629],
                                                [2.452, 2.629],
                                                [2.452, 2.629],
                                                [2.452, 2.628],
                                                [24.185, 25.91],
                                                [73.178, 0],
                                                [0, -44.067],
                                            ],
                                            v: [
                                                [231.386, 27.309],
                                                [222.931, 20.62],
                                                [214.477, 13.932],
                                                [206.022, 7.244],
                                                [197.568, 0.556],
                                                [189.113, -6.132],
                                                [180.658, -12.821],
                                                [172.204, -19.509],
                                                [163.749, -26.197],
                                                [155.295, -32.885],
                                                [146.841, -39.573],
                                                [138.386, -46.262],
                                                [129.932, -52.949],
                                                [121.477, -59.638],
                                                [113.022, -66.326],
                                                [104.569, -73.014],
                                                [96.113, -79.703],
                                                [87.653, -86.395],
                                                [79.193, -93.087],
                                                [70.733, -99.779],
                                                [62.272, -106.472],
                                                [53.812, -113.164],
                                                [45.352, -119.857],
                                                [36.891, -126.549],
                                                [28.431, -133.241],
                                                [19.971, -139.934],
                                                [11.51, -146.626],
                                                [3.05, -153.319],
                                                [-5.41, -160.011],
                                                [-13.871, -166.703],
                                                [-22.331, -173.396],
                                                [-30.791, -180.088],
                                                [-39.251, -186.78],
                                                [-47.712, -193.473],
                                                [-56.172, -200.165],
                                                [-64.632, -206.858],
                                                [-73.092, -213.55],
                                                [-81.553, -220.242],
                                                [-90.013, -226.935],
                                                [-98.474, -233.627],
                                                [-106.934, -240.319],
                                                [-178, -267],
                                                [-286, -159],
                                                [-250.049, -78.552],
                                                [-242.381, -70.966],
                                                [-234.713, -63.379],
                                                [-227.046, -55.793],
                                                [-219.378, -48.206],
                                                [-211.711, -40.62],
                                                [-204.044, -33.033],
                                                [-196.376, -25.446],
                                                [-188.709, -17.86],
                                                [-181.041, -10.273],
                                                [-173.374, -2.687],
                                                [-165.706, 4.9],
                                                [-158.039, 12.487],
                                                [-150.371, 20.073],
                                                [-142.704, 27.659],
                                                [-135.036, 35.247],
                                                [-127.369, 42.833],
                                                [-119.701, 50.419],
                                                [-112.034, 58.006],
                                                [-104.367, 65.592],
                                                [-96.699, 73.179],
                                                [-89.032, 80.766],
                                                [-81.364, 88.352],
                                                [-73.697, 95.939],
                                                [-66.029, 103.526],
                                                [-58.361, 111.112],
                                                [-50.694, 118.698],
                                                [-43.027, 126.285],
                                                [-35.359, 133.872],
                                                [-27.692, 141.458],
                                                [-20.024, 149.045],
                                                [-12.357, 156.631],
                                                [-4.689, 164.218],
                                                [2.979, 171.805],
                                                [10.646, 179.391],
                                                [18.313, 186.978],
                                                [25.977, 194.561],
                                                [33.64, 202.142],
                                                [41.302, 209.723],
                                                [48.965, 217.305],
                                                [56.627, 224.886],
                                                [153.5, 267],
                                                [286, 134.5],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'gf',
                                    s: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 22,
                                                s: [-201.545, -178.118],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 52,
                                                s: [-539.194, -533.408],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    e: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 22,
                                                s: [178.631, 158.89],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 52,
                                                s: [-252.181, -248.055],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    t: 1,
                                    g: {
                                        k: {
                                            a: 0,
                                            k: [
                                                0, 1, 0.369, 0.192, 0.5, 0.904,
                                                0.684, 0.269, 1, 0.808, 1,
                                                0.345,
                                            ],
                                        },
                                        p: 3,
                                    },
                                    nm: 'G',
                                    bm: 0,
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                    ],
                    ip: 12,
                    op: 49,
                    st: -16,
                    tt: 1,
                },
                {
                    ind: 7,
                    ty: 4,
                    nm: 'm',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            a: 0,
                            k: [554.622, 539.93, 0],
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-4.195, -2.337],
                                                [0, 0],
                                                [-24.51, 39.427],
                                                [42.492, 24.512],
                                                [0, 0],
                                                [-4.495, -1.737],
                                                [0, 0],
                                                [-0.547, -0.189],
                                                [-7.162, 0],
                                                [-2.315, 30.747],
                                                [36.381, 0],
                                                [0, 0],
                                                [-0.394, -35.661],
                                                [-13.292, -11.581],
                                                [-16.07, -12.883],
                                                [3.656, 0],
                                                [0, 0],
                                                [0, -59.008],
                                                [-22.355, -19.6],
                                                [0, 0],
                                                [-37.22, 1.102],
                                                [-0.195, 68.745],
                                                [32.277, 23.374],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.805, -2.909],
                                                [0, 0],
                                                [40.516, 22.718],
                                                [25.859, -41.597],
                                                [0, 0],
                                                [-4.135, -2.428],
                                                [0, 0],
                                                [0, 0],
                                                [6.411, 2.215],
                                                [32.694, 0],
                                                [2.997, -39.795],
                                                [-17.828, 0],
                                                [-35.751, 0],
                                                [0.21, 18.97],
                                                [10.009, 8.721],
                                                [2.877, 2.306],
                                                [0, 0],
                                                [-59.065, 0],
                                                [0, 32.064],
                                                [0, 0],
                                                [24.095, 24.334],
                                                [68.775, -2.037],
                                                [0.121, -42.852],
                                                [0, 0],
                                            ],
                                            v: [
                                                [232.124, 113.596],
                                                [232.215, 113.596],
                                                [162.932, 58.397],
                                                [8.239, -60.662],
                                                [12.526, -67.107],
                                                [101.917, -17.062],
                                                [218.192, -46.907],
                                                [187.895, -167.795],
                                                [56.698, -243.61],
                                                [60.085, -250.594],
                                                [120.349, -226.472],
                                                [122.446, -225.691],
                                                [142.884, -222.247],
                                                [204.733, -278.853],
                                                [140.904, -346.46],
                                                [-137.698, -346.491],
                                                [-203.026, -281.581],
                                                [-181.001, -234.082],
                                                [-121.127, -185.475],
                                                [-123.554, -178.582],
                                                [-178.664, -178.582],
                                                [-285.346, -71.48],
                                                [-249.116, 8.592],
                                                [65.718, 307.693],
                                                [160.804, 345.66],
                                                [285.256, 217.85],
                                                [232.094, 113.627],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'fl',
                                    nm: 'F',
                                    bm: 0,
                                    c: {
                                        a: 0,
                                        k: [
                                            0.133333333333, 0.113725490196,
                                            0.098039215686, 1,
                                        ],
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                        {
                            ty: 'op',
                            nm: 'O',
                            ml: {
                                a: 0,
                                k: 4,
                            },
                            a: {
                                a: 0,
                                k: 0,
                            },
                            lj: 1,
                        },
                    ],
                    ip: 43,
                    op: 107,
                    st: -64,
                    td: 1,
                },
                {
                    ind: 8,
                    ty: 4,
                    nm: 's',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            k: [
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833,
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167,
                                    },
                                    t: 43,
                                    s: [183, 467, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    i: {
                                        x: 0.667,
                                        y: 0.667,
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167,
                                    },
                                    t: 47,
                                    s: [531, 465, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1,
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0,
                                    },
                                    t: 102,
                                    s: [531, 465, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    t: 106,
                                    s: [203, 467, 0],
                                },
                            ],
                            a: 1,
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [-2.647, 0.422],
                                                [-2.647, 0.423],
                                                [-2.647, 0.423],
                                                [-2.647, 0.424],
                                                [-2.647, 0.424],
                                                [-2.647, 0.424],
                                                [-2.647, 0.425],
                                                [-2.647, 0.425],
                                                [-2.646, 0.426],
                                                [-2.646, 0.426],
                                                [-2.646, 0.426],
                                                [-2.646, 0.427],
                                                [-2.646, 0.427],
                                                [-2.646, 0.428],
                                                [-2.646, 0.428],
                                                [-2.645, 0.428],
                                                [-2.646, 0.429],
                                                [-2.645, 0.429],
                                                [-2.645, 0.43],
                                                [-2.645, 0.43],
                                                [-2.645, 0.431],
                                                [-2.645, 0.431],
                                                [-2.644, 0.432],
                                                [-2.644, 0.432],
                                                [-2.644, 0.433],
                                                [-2.644, 0.433],
                                                [-2.644, 0.434],
                                                [-2.643, 0.434],
                                                [-2.644, 0.435],
                                                [-2.645, 0.435],
                                                [-2.645, 0.436],
                                                [-2.645, 0.437],
                                                [-2.645, 0.437],
                                                [-2.645, 0.438],
                                                [-2.644, 0.439],
                                                [-2.644, 0.44],
                                                [-2.644, 0.44],
                                                [-2.643, 0.441],
                                                [-2.643, 0.442],
                                                [0, 46.383],
                                                [48.601, 0],
                                                [1.341, -0.061],
                                                [1.359, 0],
                                                [1.341, -0.06],
                                                [1.359, 0],
                                                [1.341, -0.06],
                                                [1.359, 0],
                                                [1.341, -0.06],
                                                [1.359, 0],
                                                [1.341, -0.059],
                                                [1.359, 0],
                                                [1.341, -0.059],
                                                [1.359, 0],
                                                [1.341, -0.059],
                                                [1.359, 0],
                                                [1.341, -0.058],
                                                [1.359, 0],
                                                [1.341, -0.058],
                                                [1.359, 0],
                                                [1.341, -0.058],
                                                [1.359, 0],
                                                [1.342, -0.057],
                                                [1.359, 0],
                                                [1.342, -0.057],
                                                [1.358, 0],
                                                [1.342, -0.057],
                                                [1.359, 0],
                                                [1.342, -0.057],
                                                [1.358, 0],
                                                [1.342, -0.056],
                                                [1.358, 0],
                                                [1.342, -0.056],
                                                [1.358, 0],
                                                [1.342, -0.056],
                                                [1.358, 0],
                                                [1.342, -0.055],
                                                [1.358, 0],
                                                [1.342, -0.055],
                                                [1.358, 0],
                                                [1.342, -0.055],
                                                [1.358, 0],
                                                [1.342, -0.055],
                                                [1.358, 0],
                                                [1.342, -0.054],
                                                [1.358, 0],
                                                [1.342, -0.054],
                                                [1.358, 0],
                                                [1.342, -0.054],
                                                [1.358, 0],
                                                [1.342, -0.054],
                                                [1.358, 0],
                                                [1.342, -0.053],
                                                [1.358, 0],
                                                [1.342, -0.053],
                                                [1.358, 0],
                                                [1.342, -0.053],
                                                [1.358, 0],
                                                [1.343, -0.053],
                                                [1.358, 0],
                                                [1.342, -0.052],
                                                [1.358, 0],
                                                [1.342, -0.052],
                                                [1.358, 0],
                                                [1.342, -0.052],
                                                [1.358, 0],
                                                [1.343, -0.052],
                                                [1.358, 0],
                                                [1.343, -0.051],
                                                [1.358, 0],
                                                [1.342, -0.051],
                                                [1.358, 0],
                                                [1.343, -0.051],
                                                [1.358, 0],
                                                [1.343, -0.051],
                                                [1.358, 0],
                                                [1.343, -0.05],
                                                [1.358, 0],
                                                [1.343, -0.05],
                                                [1.358, 0],
                                                [1.343, -0.05],
                                                [1.358, 0],
                                                [1.343, -0.05],
                                                [1.358, 0],
                                                [0, -59.647],
                                                [-59.647, 0],
                                                [-5.576, 0.888],
                                                [-2.647, 0.422],
                                            ],
                                            o: [
                                                [2.709, -0.224],
                                                [2.708, -0.223],
                                                [2.709, -0.223],
                                                [2.709, -0.222],
                                                [2.709, -0.222],
                                                [2.71, -0.221],
                                                [2.71, -0.221],
                                                [2.71, -0.22],
                                                [2.71, -0.22],
                                                [2.71, -0.219],
                                                [2.71, -0.218],
                                                [2.71, -0.218],
                                                [2.711, -0.217],
                                                [2.711, -0.217],
                                                [2.711, -0.216],
                                                [2.711, -0.215],
                                                [2.711, -0.215],
                                                [2.711, -0.214],
                                                [2.712, -0.214],
                                                [2.712, -0.213],
                                                [2.712, -0.212],
                                                [2.712, -0.212],
                                                [2.712, -0.211],
                                                [2.713, -0.21],
                                                [2.713, -0.21],
                                                [2.713, -0.209],
                                                [2.713, -0.208],
                                                [2.713, -0.208],
                                                [2.715, -0.207],
                                                [2.716, -0.206],
                                                [2.716, -0.206],
                                                [2.716, -0.205],
                                                [2.716, -0.205],
                                                [2.716, -0.204],
                                                [2.716, -0.204],
                                                [2.717, -0.203],
                                                [2.717, -0.202],
                                                [2.717, -0.202],
                                                [45.521, -3.372],
                                                [0, -48.601],
                                                [-1.356, 0],
                                                [-1.344, -0.061],
                                                [-1.356, 0],
                                                [-1.344, -0.06],
                                                [-1.356, 0],
                                                [-1.344, -0.06],
                                                [-1.356, 0],
                                                [-1.344, -0.06],
                                                [-1.356, 0],
                                                [-1.344, -0.059],
                                                [-1.356, 0],
                                                [-1.344, -0.059],
                                                [-1.356, 0],
                                                [-1.344, -0.059],
                                                [-1.356, 0],
                                                [-1.344, -0.058],
                                                [-1.356, 0],
                                                [-1.344, -0.058],
                                                [-1.356, 0],
                                                [-1.344, -0.058],
                                                [-1.356, 0],
                                                [-1.344, -0.057],
                                                [-1.356, 0],
                                                [-1.344, -0.057],
                                                [-1.356, 0],
                                                [-1.345, -0.057],
                                                [-1.356, 0],
                                                [-1.344, -0.057],
                                                [-1.356, 0],
                                                [-1.345, -0.056],
                                                [-1.356, 0],
                                                [-1.345, -0.056],
                                                [-1.356, 0],
                                                [-1.345, -0.056],
                                                [-1.356, 0],
                                                [-1.345, -0.055],
                                                [-1.356, 0],
                                                [-1.345, -0.055],
                                                [-1.355, 0],
                                                [-1.345, -0.055],
                                                [-1.355, 0],
                                                [-1.345, -0.055],
                                                [-1.355, 0],
                                                [-1.345, -0.054],
                                                [-1.355, 0],
                                                [-1.345, -0.054],
                                                [-1.356, 0],
                                                [-1.345, -0.054],
                                                [-1.355, 0],
                                                [-1.345, -0.054],
                                                [-1.355, 0],
                                                [-1.345, -0.053],
                                                [-1.355, 0],
                                                [-1.345, -0.053],
                                                [-1.355, 0],
                                                [-1.345, -0.053],
                                                [-1.355, 0],
                                                [-1.345, -0.052],
                                                [-1.355, 0],
                                                [-1.345, -0.052],
                                                [-1.355, 0],
                                                [-1.345, -0.052],
                                                [-1.355, 0],
                                                [-1.345, -0.052],
                                                [-1.355, 0],
                                                [-1.345, -0.052],
                                                [-1.355, 0],
                                                [-1.345, -0.051],
                                                [-1.355, 0],
                                                [-1.346, -0.051],
                                                [-1.355, 0],
                                                [-1.345, -0.051],
                                                [-1.355, 0],
                                                [-1.345, -0.051],
                                                [-1.355, 0],
                                                [-1.346, -0.05],
                                                [-1.355, 0],
                                                [-1.345, -0.05],
                                                [-1.355, 0],
                                                [-1.346, -0.05],
                                                [-1.355, 0],
                                                [-1.346, -0.05],
                                                [-59.647, 0],
                                                [0, 59.647],
                                                [5.826, 0],
                                                [2.708, -0.225],
                                                [2.708, -0.225],
                                            ],
                                            v: [
                                                [-122.811, 104.7],
                                                [-114.775, 103.728],
                                                [-106.74, 102.756],
                                                [-98.704, 101.784],
                                                [-90.669, 100.812],
                                                [-82.634, 99.84],
                                                [-74.598, 98.868],
                                                [-66.562, 97.896],
                                                [-58.527, 96.924],
                                                [-50.492, 95.952],
                                                [-42.456, 94.98],
                                                [-34.42, 94.008],
                                                [-26.386, 93.036],
                                                [-18.35, 92.064],
                                                [-10.314, 91.092],
                                                [-2.28, 90.12],
                                                [5.757, 89.148],
                                                [13.792, 88.176],
                                                [21.826, 87.204],
                                                [29.863, 86.232],
                                                [37.898, 85.26],
                                                [45.934, 84.288],
                                                [53.969, 83.316],
                                                [62.004, 82.344],
                                                [70.04, 81.372],
                                                [78.075, 80.4],
                                                [86.111, 79.428],
                                                [94.145, 78.456],
                                                [102.181, 77.484],
                                                [110.22, 76.512],
                                                [118.262, 75.539],
                                                [126.304, 74.566],
                                                [134.345, 73.593],
                                                [142.386, 72.62],
                                                [150.428, 71.647],
                                                [158.469, 70.674],
                                                [166.511, 69.701],
                                                [174.553, 68.728],
                                                [182.594, 67.755],
                                                [264, -20],
                                                [176, -108],
                                                [171.956, -107.904],
                                                [167.902, -108],
                                                [163.858, -107.904],
                                                [159.805, -108],
                                                [155.76, -107.905],
                                                [151.707, -108],
                                                [147.663, -107.905],
                                                [143.61, -108],
                                                [139.565, -107.905],
                                                [135.512, -108],
                                                [131.468, -107.905],
                                                [127.415, -108],
                                                [123.37, -107.906],
                                                [119.317, -108],
                                                [115.273, -107.906],
                                                [111.219, -108],
                                                [107.175, -107.906],
                                                [103.122, -108],
                                                [99.078, -107.907],
                                                [95.024, -108],
                                                [90.98, -107.907],
                                                [86.927, -108],
                                                [82.882, -107.907],
                                                [78.829, -108],
                                                [74.785, -107.908],
                                                [70.732, -108],
                                                [66.687, -107.908],
                                                [62.634, -108],
                                                [58.59, -107.908],
                                                [54.537, -108],
                                                [50.492, -107.909],
                                                [46.439, -108],
                                                [42.394, -107.909],
                                                [38.341, -108],
                                                [34.297, -107.909],
                                                [30.244, -108],
                                                [26.199, -107.91],
                                                [22.146, -108],
                                                [18.102, -107.91],
                                                [14.049, -108],
                                                [10.004, -107.91],
                                                [5.951, -108],
                                                [1.907, -107.911],
                                                [-2.146, -108],
                                                [-6.191, -107.911],
                                                [-10.244, -108],
                                                [-14.289, -107.911],
                                                [-18.341, -108],
                                                [-22.386, -107.911],
                                                [-26.439, -108],
                                                [-30.484, -107.912],
                                                [-34.537, -108],
                                                [-38.581, -107.912],
                                                [-42.634, -108],
                                                [-46.679, -107.912],
                                                [-50.732, -108],
                                                [-54.777, -107.913],
                                                [-58.829, -108],
                                                [-62.873, -107.913],
                                                [-66.927, -108],
                                                [-70.971, -107.913],
                                                [-75.024, -108],
                                                [-79.069, -107.914],
                                                [-83.122, -108],
                                                [-87.167, -107.914],
                                                [-91.219, -108],
                                                [-95.264, -107.914],
                                                [-99.317, -108],
                                                [-103.361, -107.915],
                                                [-107.415, -108],
                                                [-111.459, -107.915],
                                                [-115.512, -108],
                                                [-119.557, -107.915],
                                                [-123.61, -108],
                                                [-127.654, -107.916],
                                                [-131.707, -108],
                                                [-135.752, -107.916],
                                                [-139.805, -108],
                                                [-143.849, -107.916],
                                                [-147.902, -108],
                                                [-151.947, -107.917],
                                                [-156, -108],
                                                [-264, 0],
                                                [-156, 108],
                                                [-138.881, 106.644],
                                                [-130.846, 105.672],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'gf',
                                    s: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 43,
                                                s: [-610.99, 38.241],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 51,
                                                s: [-12.798, -3.907],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    e: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 43,
                                                s: [58.116, -8.969],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 51,
                                                s: [527.706, -40.213],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    t: 1,
                                    g: {
                                        k: {
                                            a: 0,
                                            k: [
                                                0, 1, 0.757, 0.925, 0.5, 0.904,
                                                0.878, 0.635, 1, 0.808, 1,
                                                0.345,
                                            ],
                                        },
                                        p: 3,
                                    },
                                    nm: 'G',
                                    bm: 0,
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                    ],
                    ip: 43,
                    op: 107,
                    st: 8,
                    tt: 1,
                },
                {
                    ind: 9,
                    ty: 4,
                    nm: 'm',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            a: 0,
                            k: [554.622, 539.93, 0],
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-4.195, -2.337],
                                                [0, 0],
                                                [-24.51, 39.427],
                                                [42.492, 24.512],
                                                [0, 0],
                                                [-4.495, -1.737],
                                                [0, 0],
                                                [-0.547, -0.189],
                                                [-7.162, 0],
                                                [-2.315, 30.747],
                                                [36.381, 0],
                                                [0, 0],
                                                [-0.394, -35.661],
                                                [-13.292, -11.581],
                                                [-16.07, -12.883],
                                                [3.656, 0],
                                                [0, 0],
                                                [0, -59.008],
                                                [-22.355, -19.6],
                                                [0, 0],
                                                [-37.22, 1.102],
                                                [-0.195, 68.745],
                                                [32.277, 23.374],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.805, -2.909],
                                                [0, 0],
                                                [40.516, 22.718],
                                                [25.859, -41.597],
                                                [0, 0],
                                                [-4.135, -2.428],
                                                [0, 0],
                                                [0, 0],
                                                [6.411, 2.215],
                                                [32.694, 0],
                                                [2.997, -39.795],
                                                [-17.828, 0],
                                                [-35.751, 0],
                                                [0.21, 18.97],
                                                [10.009, 8.721],
                                                [2.877, 2.306],
                                                [0, 0],
                                                [-59.065, 0],
                                                [0, 32.064],
                                                [0, 0],
                                                [24.095, 24.334],
                                                [68.775, -2.037],
                                                [0.121, -42.852],
                                                [0, 0],
                                            ],
                                            v: [
                                                [232.124, 113.596],
                                                [232.215, 113.596],
                                                [162.932, 58.397],
                                                [8.239, -60.662],
                                                [12.526, -67.107],
                                                [101.917, -17.062],
                                                [218.192, -46.907],
                                                [187.895, -167.795],
                                                [56.698, -243.61],
                                                [60.085, -250.594],
                                                [120.349, -226.472],
                                                [122.446, -225.691],
                                                [142.884, -222.247],
                                                [204.733, -278.853],
                                                [140.904, -346.46],
                                                [-137.698, -346.491],
                                                [-203.026, -281.581],
                                                [-181.001, -234.082],
                                                [-121.127, -185.475],
                                                [-123.554, -178.582],
                                                [-178.664, -178.582],
                                                [-285.346, -71.48],
                                                [-249.116, 8.592],
                                                [65.718, 307.693],
                                                [160.804, 345.66],
                                                [285.256, 217.85],
                                                [232.094, 113.627],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'fl',
                                    nm: 'F',
                                    bm: 0,
                                    c: {
                                        a: 0,
                                        k: [
                                            0.133333333333, 0.113725490196,
                                            0.098039215686, 1,
                                        ],
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                        {
                            ty: 'op',
                            nm: 'O',
                            ml: {
                                a: 0,
                                k: 4,
                            },
                            a: {
                                a: 0,
                                k: 0,
                            },
                            lj: 1,
                        },
                    ],
                    ip: 30,
                    op: 57,
                    st: -77,
                    td: 1,
                },
                {
                    ind: 10,
                    ty: 4,
                    nm: 's',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            k: [
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833,
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167,
                                    },
                                    t: 30,
                                    s: [183, 467, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    t: 40,
                                    s: [531, 465, 0],
                                },
                            ],
                            a: 1,
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [-2.647, 0.422],
                                                [-2.647, 0.423],
                                                [-2.647, 0.423],
                                                [-2.647, 0.424],
                                                [-2.647, 0.424],
                                                [-2.647, 0.424],
                                                [-2.647, 0.425],
                                                [-2.647, 0.425],
                                                [-2.646, 0.426],
                                                [-2.646, 0.426],
                                                [-2.646, 0.426],
                                                [-2.646, 0.427],
                                                [-2.646, 0.427],
                                                [-2.646, 0.428],
                                                [-2.646, 0.428],
                                                [-2.645, 0.428],
                                                [-2.646, 0.429],
                                                [-2.645, 0.429],
                                                [-2.645, 0.43],
                                                [-2.645, 0.43],
                                                [-2.645, 0.431],
                                                [-2.645, 0.431],
                                                [-2.644, 0.432],
                                                [-2.644, 0.432],
                                                [-2.644, 0.433],
                                                [-2.644, 0.433],
                                                [-2.644, 0.434],
                                                [-2.643, 0.434],
                                                [-2.644, 0.435],
                                                [-2.645, 0.435],
                                                [-2.645, 0.436],
                                                [-2.645, 0.437],
                                                [-2.645, 0.437],
                                                [-2.645, 0.438],
                                                [-2.644, 0.439],
                                                [-2.644, 0.44],
                                                [-2.644, 0.44],
                                                [-2.643, 0.441],
                                                [-2.643, 0.442],
                                                [0, 46.383],
                                                [48.601, 0],
                                                [1.341, -0.061],
                                                [1.359, 0],
                                                [1.341, -0.06],
                                                [1.359, 0],
                                                [1.341, -0.06],
                                                [1.359, 0],
                                                [1.341, -0.06],
                                                [1.359, 0],
                                                [1.341, -0.059],
                                                [1.359, 0],
                                                [1.341, -0.059],
                                                [1.359, 0],
                                                [1.341, -0.059],
                                                [1.359, 0],
                                                [1.341, -0.058],
                                                [1.359, 0],
                                                [1.341, -0.058],
                                                [1.359, 0],
                                                [1.341, -0.058],
                                                [1.359, 0],
                                                [1.342, -0.057],
                                                [1.359, 0],
                                                [1.342, -0.057],
                                                [1.358, 0],
                                                [1.342, -0.057],
                                                [1.359, 0],
                                                [1.342, -0.057],
                                                [1.358, 0],
                                                [1.342, -0.056],
                                                [1.358, 0],
                                                [1.342, -0.056],
                                                [1.358, 0],
                                                [1.342, -0.056],
                                                [1.358, 0],
                                                [1.342, -0.055],
                                                [1.358, 0],
                                                [1.342, -0.055],
                                                [1.358, 0],
                                                [1.342, -0.055],
                                                [1.358, 0],
                                                [1.342, -0.055],
                                                [1.358, 0],
                                                [1.342, -0.054],
                                                [1.358, 0],
                                                [1.342, -0.054],
                                                [1.358, 0],
                                                [1.342, -0.054],
                                                [1.358, 0],
                                                [1.342, -0.054],
                                                [1.358, 0],
                                                [1.342, -0.053],
                                                [1.358, 0],
                                                [1.342, -0.053],
                                                [1.358, 0],
                                                [1.342, -0.053],
                                                [1.358, 0],
                                                [1.343, -0.053],
                                                [1.358, 0],
                                                [1.342, -0.052],
                                                [1.358, 0],
                                                [1.342, -0.052],
                                                [1.358, 0],
                                                [1.342, -0.052],
                                                [1.358, 0],
                                                [1.343, -0.052],
                                                [1.358, 0],
                                                [1.343, -0.051],
                                                [1.358, 0],
                                                [1.342, -0.051],
                                                [1.358, 0],
                                                [1.343, -0.051],
                                                [1.358, 0],
                                                [1.343, -0.051],
                                                [1.358, 0],
                                                [1.343, -0.05],
                                                [1.358, 0],
                                                [1.343, -0.05],
                                                [1.358, 0],
                                                [1.343, -0.05],
                                                [1.358, 0],
                                                [1.343, -0.05],
                                                [1.358, 0],
                                                [0, -59.647],
                                                [-59.647, 0],
                                                [-5.576, 0.888],
                                                [-2.647, 0.422],
                                            ],
                                            o: [
                                                [2.709, -0.224],
                                                [2.708, -0.223],
                                                [2.709, -0.223],
                                                [2.709, -0.222],
                                                [2.709, -0.222],
                                                [2.71, -0.221],
                                                [2.71, -0.221],
                                                [2.71, -0.22],
                                                [2.71, -0.22],
                                                [2.71, -0.219],
                                                [2.71, -0.218],
                                                [2.71, -0.218],
                                                [2.711, -0.217],
                                                [2.711, -0.217],
                                                [2.711, -0.216],
                                                [2.711, -0.215],
                                                [2.711, -0.215],
                                                [2.711, -0.214],
                                                [2.712, -0.214],
                                                [2.712, -0.213],
                                                [2.712, -0.212],
                                                [2.712, -0.212],
                                                [2.712, -0.211],
                                                [2.713, -0.21],
                                                [2.713, -0.21],
                                                [2.713, -0.209],
                                                [2.713, -0.208],
                                                [2.713, -0.208],
                                                [2.715, -0.207],
                                                [2.716, -0.206],
                                                [2.716, -0.206],
                                                [2.716, -0.205],
                                                [2.716, -0.205],
                                                [2.716, -0.204],
                                                [2.716, -0.204],
                                                [2.717, -0.203],
                                                [2.717, -0.202],
                                                [2.717, -0.202],
                                                [45.521, -3.372],
                                                [0, -48.601],
                                                [-1.356, 0],
                                                [-1.344, -0.061],
                                                [-1.356, 0],
                                                [-1.344, -0.06],
                                                [-1.356, 0],
                                                [-1.344, -0.06],
                                                [-1.356, 0],
                                                [-1.344, -0.06],
                                                [-1.356, 0],
                                                [-1.344, -0.059],
                                                [-1.356, 0],
                                                [-1.344, -0.059],
                                                [-1.356, 0],
                                                [-1.344, -0.059],
                                                [-1.356, 0],
                                                [-1.344, -0.058],
                                                [-1.356, 0],
                                                [-1.344, -0.058],
                                                [-1.356, 0],
                                                [-1.344, -0.058],
                                                [-1.356, 0],
                                                [-1.344, -0.057],
                                                [-1.356, 0],
                                                [-1.344, -0.057],
                                                [-1.356, 0],
                                                [-1.345, -0.057],
                                                [-1.356, 0],
                                                [-1.344, -0.057],
                                                [-1.356, 0],
                                                [-1.345, -0.056],
                                                [-1.356, 0],
                                                [-1.345, -0.056],
                                                [-1.356, 0],
                                                [-1.345, -0.056],
                                                [-1.356, 0],
                                                [-1.345, -0.055],
                                                [-1.356, 0],
                                                [-1.345, -0.055],
                                                [-1.355, 0],
                                                [-1.345, -0.055],
                                                [-1.355, 0],
                                                [-1.345, -0.055],
                                                [-1.355, 0],
                                                [-1.345, -0.054],
                                                [-1.355, 0],
                                                [-1.345, -0.054],
                                                [-1.356, 0],
                                                [-1.345, -0.054],
                                                [-1.355, 0],
                                                [-1.345, -0.054],
                                                [-1.355, 0],
                                                [-1.345, -0.053],
                                                [-1.355, 0],
                                                [-1.345, -0.053],
                                                [-1.355, 0],
                                                [-1.345, -0.053],
                                                [-1.355, 0],
                                                [-1.345, -0.052],
                                                [-1.355, 0],
                                                [-1.345, -0.052],
                                                [-1.355, 0],
                                                [-1.345, -0.052],
                                                [-1.355, 0],
                                                [-1.345, -0.052],
                                                [-1.355, 0],
                                                [-1.345, -0.052],
                                                [-1.355, 0],
                                                [-1.345, -0.051],
                                                [-1.355, 0],
                                                [-1.346, -0.051],
                                                [-1.355, 0],
                                                [-1.345, -0.051],
                                                [-1.355, 0],
                                                [-1.345, -0.051],
                                                [-1.355, 0],
                                                [-1.346, -0.05],
                                                [-1.355, 0],
                                                [-1.345, -0.05],
                                                [-1.355, 0],
                                                [-1.346, -0.05],
                                                [-1.355, 0],
                                                [-1.346, -0.05],
                                                [-59.647, 0],
                                                [0, 59.647],
                                                [5.826, 0],
                                                [2.708, -0.225],
                                                [2.708, -0.225],
                                            ],
                                            v: [
                                                [-122.811, 104.7],
                                                [-114.775, 103.728],
                                                [-106.74, 102.756],
                                                [-98.704, 101.784],
                                                [-90.669, 100.812],
                                                [-82.634, 99.84],
                                                [-74.598, 98.868],
                                                [-66.562, 97.896],
                                                [-58.527, 96.924],
                                                [-50.492, 95.952],
                                                [-42.456, 94.98],
                                                [-34.42, 94.008],
                                                [-26.386, 93.036],
                                                [-18.35, 92.064],
                                                [-10.314, 91.092],
                                                [-2.28, 90.12],
                                                [5.757, 89.148],
                                                [13.792, 88.176],
                                                [21.826, 87.204],
                                                [29.863, 86.232],
                                                [37.898, 85.26],
                                                [45.934, 84.288],
                                                [53.969, 83.316],
                                                [62.004, 82.344],
                                                [70.04, 81.372],
                                                [78.075, 80.4],
                                                [86.111, 79.428],
                                                [94.145, 78.456],
                                                [102.181, 77.484],
                                                [110.22, 76.512],
                                                [118.262, 75.539],
                                                [126.304, 74.566],
                                                [134.345, 73.593],
                                                [142.386, 72.62],
                                                [150.428, 71.647],
                                                [158.469, 70.674],
                                                [166.511, 69.701],
                                                [174.553, 68.728],
                                                [182.594, 67.755],
                                                [264, -20],
                                                [176, -108],
                                                [171.956, -107.904],
                                                [167.902, -108],
                                                [163.858, -107.904],
                                                [159.805, -108],
                                                [155.76, -107.905],
                                                [151.707, -108],
                                                [147.663, -107.905],
                                                [143.61, -108],
                                                [139.565, -107.905],
                                                [135.512, -108],
                                                [131.468, -107.905],
                                                [127.415, -108],
                                                [123.37, -107.906],
                                                [119.317, -108],
                                                [115.273, -107.906],
                                                [111.219, -108],
                                                [107.175, -107.906],
                                                [103.122, -108],
                                                [99.078, -107.907],
                                                [95.024, -108],
                                                [90.98, -107.907],
                                                [86.927, -108],
                                                [82.882, -107.907],
                                                [78.829, -108],
                                                [74.785, -107.908],
                                                [70.732, -108],
                                                [66.687, -107.908],
                                                [62.634, -108],
                                                [58.59, -107.908],
                                                [54.537, -108],
                                                [50.492, -107.909],
                                                [46.439, -108],
                                                [42.394, -107.909],
                                                [38.341, -108],
                                                [34.297, -107.909],
                                                [30.244, -108],
                                                [26.199, -107.91],
                                                [22.146, -108],
                                                [18.102, -107.91],
                                                [14.049, -108],
                                                [10.004, -107.91],
                                                [5.951, -108],
                                                [1.907, -107.911],
                                                [-2.146, -108],
                                                [-6.191, -107.911],
                                                [-10.244, -108],
                                                [-14.289, -107.911],
                                                [-18.341, -108],
                                                [-22.386, -107.911],
                                                [-26.439, -108],
                                                [-30.484, -107.912],
                                                [-34.537, -108],
                                                [-38.581, -107.912],
                                                [-42.634, -108],
                                                [-46.679, -107.912],
                                                [-50.732, -108],
                                                [-54.777, -107.913],
                                                [-58.829, -108],
                                                [-62.873, -107.913],
                                                [-66.927, -108],
                                                [-70.971, -107.913],
                                                [-75.024, -108],
                                                [-79.069, -107.914],
                                                [-83.122, -108],
                                                [-87.167, -107.914],
                                                [-91.219, -108],
                                                [-95.264, -107.914],
                                                [-99.317, -108],
                                                [-103.361, -107.915],
                                                [-107.415, -108],
                                                [-111.459, -107.915],
                                                [-115.512, -108],
                                                [-119.557, -107.915],
                                                [-123.61, -108],
                                                [-127.654, -107.916],
                                                [-131.707, -108],
                                                [-135.752, -107.916],
                                                [-139.805, -108],
                                                [-143.849, -107.916],
                                                [-147.902, -108],
                                                [-151.947, -107.917],
                                                [-156, -108],
                                                [-264, 0],
                                                [-156, 108],
                                                [-138.881, 106.644],
                                                [-130.846, 105.672],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'gf',
                                    s: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 35,
                                                s: [-610.99, 38.241],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 45,
                                                s: [211.525, -19.712],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    e: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 35,
                                                s: [58.116, -8.969],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 45,
                                                s: [703.803, -51.93],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    t: 1,
                                    g: {
                                        k: {
                                            a: 0,
                                            k: [
                                                0, 0.808, 1, 0.345, 0.5, 0.904,
                                                0.684, 0.269, 1, 1, 0.369,
                                                0.192,
                                            ],
                                        },
                                        p: 3,
                                    },
                                    nm: 'G',
                                    bm: 0,
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                    ],
                    ip: 30,
                    op: 57,
                    st: -5,
                    tt: 1,
                },
                {
                    ind: 11,
                    ty: 4,
                    nm: 'm',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            a: 0,
                            k: [554.622, 539.93, 0],
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-4.195, -2.337],
                                                [0, 0],
                                                [-24.51, 39.427],
                                                [42.492, 24.512],
                                                [0, 0],
                                                [-4.495, -1.737],
                                                [0, 0],
                                                [-0.547, -0.189],
                                                [-7.162, 0],
                                                [-2.315, 30.747],
                                                [36.381, 0],
                                                [0, 0],
                                                [-0.394, -35.661],
                                                [-13.292, -11.581],
                                                [-16.07, -12.883],
                                                [3.656, 0],
                                                [0, 0],
                                                [0, -59.008],
                                                [-22.355, -19.6],
                                                [0, 0],
                                                [-37.22, 1.102],
                                                [-0.195, 68.745],
                                                [32.277, 23.374],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.805, -2.909],
                                                [0, 0],
                                                [40.516, 22.718],
                                                [25.859, -41.597],
                                                [0, 0],
                                                [-4.135, -2.428],
                                                [0, 0],
                                                [0, 0],
                                                [6.411, 2.215],
                                                [32.694, 0],
                                                [2.997, -39.795],
                                                [-17.828, 0],
                                                [-35.751, 0],
                                                [0.21, 18.97],
                                                [10.009, 8.721],
                                                [2.877, 2.306],
                                                [0, 0],
                                                [-59.065, 0],
                                                [0, 32.064],
                                                [0, 0],
                                                [24.095, 24.334],
                                                [68.775, -2.037],
                                                [0.121, -42.852],
                                                [0, 0],
                                            ],
                                            v: [
                                                [232.124, 113.596],
                                                [232.215, 113.596],
                                                [162.932, 58.397],
                                                [8.239, -60.662],
                                                [12.526, -67.107],
                                                [101.917, -17.062],
                                                [218.192, -46.907],
                                                [187.895, -167.795],
                                                [56.698, -243.61],
                                                [60.085, -250.594],
                                                [120.349, -226.472],
                                                [122.446, -225.691],
                                                [142.884, -222.247],
                                                [204.733, -278.853],
                                                [140.904, -346.46],
                                                [-137.698, -346.491],
                                                [-203.026, -281.581],
                                                [-181.001, -234.082],
                                                [-121.127, -185.475],
                                                [-123.554, -178.582],
                                                [-178.664, -178.582],
                                                [-285.346, -71.48],
                                                [-249.116, 8.592],
                                                [65.718, 307.693],
                                                [160.804, 345.66],
                                                [285.256, 217.85],
                                                [232.094, 113.627],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'fl',
                                    nm: 'F',
                                    bm: 0,
                                    c: {
                                        a: 0,
                                        k: [
                                            0.133333333333, 0.113725490196,
                                            0.098039215686, 1,
                                        ],
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                        {
                            ty: 'op',
                            nm: 'O',
                            ml: {
                                a: 0,
                                k: 4,
                            },
                            a: {
                                a: 0,
                                k: 0,
                            },
                            lj: 1,
                        },
                    ],
                    ip: 68,
                    op: 103,
                    st: -39,
                    td: 1,
                },
                {
                    ind: 12,
                    ty: 4,
                    nm: 'L',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            k: [
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833,
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167,
                                    },
                                    t: 69,
                                    s: [885, 574, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    i: {
                                        x: 0.667,
                                        y: 0.667,
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167,
                                    },
                                    t: 76,
                                    s: [537, 370, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1,
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0,
                                    },
                                    t: 99,
                                    s: [537, 370, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    t: 103,
                                    s: [889, 576, 0],
                                },
                            ],
                            a: 1,
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [124.277, 124.277, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [28.142, 14.681],
                                                [2.471, 1.288],
                                                [2.471, 1.288],
                                                [2.54, 1.315],
                                                [2.406, 1.252],
                                                [2.471, 1.286],
                                                [2.471, 1.285],
                                                [2.472, 1.285],
                                                [2.472, 1.284],
                                                [2.472, 1.284],
                                                [2.473, 1.283],
                                                [2.473, 1.283],
                                                [2.473, 1.282],
                                                [2.474, 1.282],
                                                [2.474, 1.281],
                                                [2.474, 1.281],
                                                [2.475, 1.281],
                                                [2.474, 1.28],
                                                [2.475, 1.279],
                                                [2.475, 1.279],
                                                [2.475, 1.278],
                                                [2.476, 1.278],
                                                [2.476, 1.277],
                                                [2.477, 1.277],
                                                [2.477, 1.276],
                                                [2.477, 1.276],
                                                [2.478, 1.275],
                                                [2.478, 1.275],
                                                [2.479, 1.274],
                                                [2.479, 1.273],
                                                [2.479, 1.273],
                                                [2.48, 1.272],
                                                [2.48, 1.272],
                                                [2.48, 1.271],
                                                [2.481, 1.271],
                                                [2.481, 1.27],
                                                [2.481, 1.269],
                                                [2.482, 1.269],
                                                [2.482, 1.268],
                                                [2.482, 1.267],
                                                [2.483, 1.267],
                                                [14.737, 0],
                                                [0, -39.765],
                                                [-20.14, -12.764],
                                                [-2.353, -1.492],
                                                [-2.352, -1.492],
                                                [-2.352, -1.493],
                                                [-2.351, -1.494],
                                                [-2.351, -1.494],
                                                [-2.35, -1.495],
                                                [-2.35, -1.496],
                                                [-2.349, -1.496],
                                                [-2.349, -1.497],
                                                [-2.348, -1.497],
                                                [-2.348, -1.498],
                                                [-2.348, -1.499],
                                                [-2.347, -1.499],
                                                [-2.347, -1.5],
                                                [-2.346, -1.5],
                                                [-2.346, -1.501],
                                                [-2.346, -1.501],
                                                [-2.345, -1.502],
                                                [-2.345, -1.503],
                                                [-2.345, -1.503],
                                                [-2.344, -1.503],
                                                [-2.344, -1.504],
                                                [-2.343, -1.505],
                                                [-2.343, -1.505],
                                                [-2.343, -1.506],
                                                [-2.342, -1.506],
                                                [-2.342, -1.507],
                                                [-2.342, -1.507],
                                                [-2.341, -1.508],
                                                [-2.341, -1.508],
                                                [-2.34, -1.509],
                                                [-2.34, -1.509],
                                                [-2.34, -1.51],
                                                [-2.34, -1.51],
                                                [-2.339, -1.51],
                                                [-2.339, -1.511],
                                                [-2.28, -1.481],
                                                [-2.392, -1.547],
                                                [-2.336, -1.511],
                                                [-2.335, -1.512],
                                                [-20.603, 0],
                                                [0, 48.601],
                                            ],
                                            o: [
                                                [-2.326, -1.51],
                                                [-2.326, -1.51],
                                                [-2.386, -1.55],
                                                [-2.267, -1.465],
                                                [-2.323, -1.511],
                                                [-2.323, -1.512],
                                                [-2.323, -1.512],
                                                [-2.322, -1.513],
                                                [-2.322, -1.513],
                                                [-2.321, -1.514],
                                                [-2.321, -1.515],
                                                [-2.321, -1.515],
                                                [-2.32, -1.516],
                                                [-2.32, -1.516],
                                                [-2.319, -1.517],
                                                [-2.319, -1.518],
                                                [-2.318, -1.518],
                                                [-2.318, -1.519],
                                                [-2.318, -1.52],
                                                [-2.317, -1.52],
                                                [-2.317, -1.521],
                                                [-2.316, -1.522],
                                                [-2.316, -1.522],
                                                [-2.315, -1.523],
                                                [-2.315, -1.524],
                                                [-2.314, -1.524],
                                                [-2.314, -1.525],
                                                [-2.313, -1.526],
                                                [-2.313, -1.526],
                                                [-2.312, -1.527],
                                                [-2.312, -1.528],
                                                [-2.311, -1.529],
                                                [-2.311, -1.529],
                                                [-2.31, -1.53],
                                                [-2.31, -1.531],
                                                [-2.309, -1.531],
                                                [-2.309, -1.533],
                                                [-2.308, -1.533],
                                                [-2.307, -1.534],
                                                [-2.307, -1.535],
                                                [-11.411, -7.597],
                                                [-39.765, 0],
                                                [0, 25.608],
                                                [2.158, 1.745],
                                                [2.159, 1.745],
                                                [2.159, 1.744],
                                                [2.16, 1.743],
                                                [2.16, 1.743],
                                                [2.161, 1.742],
                                                [2.161, 1.741],
                                                [2.162, 1.741],
                                                [2.163, 1.74],
                                                [2.163, 1.739],
                                                [2.164, 1.739],
                                                [2.164, 1.738],
                                                [2.165, 1.737],
                                                [2.165, 1.737],
                                                [2.166, 1.736],
                                                [2.166, 1.736],
                                                [2.167, 1.735],
                                                [2.167, 1.734],
                                                [2.168, 1.734],
                                                [2.168, 1.733],
                                                [2.169, 1.732],
                                                [2.169, 1.732],
                                                [2.17, 1.731],
                                                [2.17, 1.731],
                                                [2.171, 1.73],
                                                [2.171, 1.73],
                                                [2.171, 1.729],
                                                [2.172, 1.729],
                                                [2.173, 1.728],
                                                [2.173, 1.727],
                                                [2.173, 1.727],
                                                [2.174, 1.726],
                                                [2.174, 1.726],
                                                [2.175, 1.726],
                                                [2.175, 1.725],
                                                [2.175, 1.724],
                                                [2.125, 1.683],
                                                [2.222, 1.768],
                                                [2.175, 1.721],
                                                [2.175, 1.721],
                                                [14.995, 11.86],
                                                [48.601, 0],
                                                [0, -33.939],
                                            ],
                                            v: [
                                                [176.142, 6.933],
                                                [168.944, 2.733],
                                                [161.745, -1.467],
                                                [154.353, -5.769],
                                                [147.343, -9.849],
                                                [140.148, -14.047],
                                                [132.954, -18.244],
                                                [125.76, -22.442],
                                                [118.565, -26.64],
                                                [111.371, -30.838],
                                                [104.176, -35.035],
                                                [96.982, -39.233],
                                                [89.787, -43.431],
                                                [82.593, -47.628],
                                                [75.399, -51.826],
                                                [68.205, -56.024],
                                                [61.01, -60.222],
                                                [53.816, -64.419],
                                                [46.621, -68.617],
                                                [39.427, -72.815],
                                                [32.233, -77.012],
                                                [25.038, -81.21],
                                                [17.844, -85.408],
                                                [10.649, -89.606],
                                                [3.455, -93.804],
                                                [-3.74, -98.001],
                                                [-10.934, -102.199],
                                                [-18.128, -106.397],
                                                [-25.323, -110.595],
                                                [-32.517, -114.792],
                                                [-39.711, -118.99],
                                                [-46.906, -123.188],
                                                [-54.1, -127.385],
                                                [-61.294, -131.583],
                                                [-68.489, -135.781],
                                                [-75.683, -139.979],
                                                [-82.877, -144.176],
                                                [-90.072, -148.374],
                                                [-97.266, -152.572],
                                                [-104.461, -156.769],
                                                [-111.655, -160.967],
                                                [-151.5, -173],
                                                [-223.5, -101],
                                                [-189.979, -40.158],
                                                [-183.205, -35.302],
                                                [-176.432, -30.447],
                                                [-169.658, -25.592],
                                                [-162.884, -20.737],
                                                [-156.11, -15.882],
                                                [-149.336, -11.027],
                                                [-142.562, -6.172],
                                                [-135.788, -1.317],
                                                [-129.014, 3.539],
                                                [-122.24, 8.394],
                                                [-115.466, 13.249],
                                                [-108.692, 18.104],
                                                [-101.919, 22.959],
                                                [-95.144, 27.814],
                                                [-88.371, 32.669],
                                                [-81.597, 37.524],
                                                [-74.823, 42.379],
                                                [-68.049, 47.235],
                                                [-61.275, 52.09],
                                                [-54.501, 56.945],
                                                [-47.727, 61.8],
                                                [-40.953, 66.655],
                                                [-34.179, 71.51],
                                                [-27.405, 76.366],
                                                [-20.631, 81.221],
                                                [-13.857, 86.076],
                                                [-7.084, 90.93],
                                                [-0.31, 95.786],
                                                [6.464, 100.641],
                                                [13.238, 105.496],
                                                [20.012, 110.351],
                                                [26.786, 115.206],
                                                [33.559, 120.061],
                                                [40.334, 124.917],
                                                [47.108, 129.772],
                                                [53.882, 134.627],
                                                [60.49, 139.376],
                                                [67.415, 144.353],
                                                [74.184, 149.205],
                                                [80.954, 154.057],
                                                [135.5, 173],
                                                [223.5, 85],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'gf',
                                    s: {
                                        a: 0,
                                        k: [-201.545, -178.118],
                                    },
                                    e: {
                                        a: 0,
                                        k: [178.631, 158.89],
                                    },
                                    t: 1,
                                    g: {
                                        k: {
                                            a: 0,
                                            k: [
                                                0, 0.808, 1, 0.345, 0.5, 0.904,
                                                0.878, 0.635, 0.999, 1, 0.757,
                                                0.925,
                                            ],
                                        },
                                        p: 3,
                                    },
                                    nm: 'G',
                                    bm: 0,
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                    ],
                    ip: 68,
                    op: 103,
                    st: 34,
                    tt: 1,
                },
                {
                    ind: 13,
                    ty: 4,
                    nm: 'm',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            a: 0,
                            k: [554.622, 539.93, 0],
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-4.195, -2.337],
                                                [0, 0],
                                                [-24.51, 39.427],
                                                [42.492, 24.512],
                                                [0, 0],
                                                [-4.495, -1.737],
                                                [0, 0],
                                                [-0.547, -0.189],
                                                [-7.162, 0],
                                                [-2.315, 30.747],
                                                [36.381, 0],
                                                [0, 0],
                                                [-0.394, -35.661],
                                                [-13.292, -11.581],
                                                [-16.07, -12.883],
                                                [3.656, 0],
                                                [0, 0],
                                                [0, -59.008],
                                                [-22.355, -19.6],
                                                [0, 0],
                                                [-37.22, 1.102],
                                                [-0.195, 68.745],
                                                [32.277, 23.374],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.805, -2.909],
                                                [0, 0],
                                                [40.516, 22.718],
                                                [25.859, -41.597],
                                                [0, 0],
                                                [-4.135, -2.428],
                                                [0, 0],
                                                [0, 0],
                                                [6.411, 2.215],
                                                [32.694, 0],
                                                [2.997, -39.795],
                                                [-17.828, 0],
                                                [-35.751, 0],
                                                [0.21, 18.97],
                                                [10.009, 8.721],
                                                [2.877, 2.306],
                                                [0, 0],
                                                [-59.065, 0],
                                                [0, 32.064],
                                                [0, 0],
                                                [24.095, 24.334],
                                                [68.775, -2.037],
                                                [0.121, -42.852],
                                                [0, 0],
                                            ],
                                            v: [
                                                [232.124, 113.596],
                                                [232.215, 113.596],
                                                [162.932, 58.397],
                                                [8.239, -60.662],
                                                [12.526, -67.107],
                                                [101.917, -17.062],
                                                [218.192, -46.907],
                                                [187.895, -167.795],
                                                [56.698, -243.61],
                                                [60.085, -250.594],
                                                [120.349, -226.472],
                                                [122.446, -225.691],
                                                [142.884, -222.247],
                                                [204.733, -278.853],
                                                [140.904, -346.46],
                                                [-137.698, -346.491],
                                                [-203.026, -281.581],
                                                [-181.001, -234.082],
                                                [-121.127, -185.475],
                                                [-123.554, -178.582],
                                                [-178.664, -178.582],
                                                [-285.346, -71.48],
                                                [-249.116, 8.592],
                                                [65.718, 307.693],
                                                [160.804, 345.66],
                                                [285.256, 217.85],
                                                [232.094, 113.627],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'fl',
                                    nm: 'F',
                                    bm: 0,
                                    c: {
                                        a: 0,
                                        k: [
                                            0.133333333333, 0.113725490196,
                                            0.098039215686, 1,
                                        ],
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                        {
                            ty: 'op',
                            nm: 'O',
                            ml: {
                                a: 0,
                                k: 4,
                            },
                            a: {
                                a: 0,
                                k: 0,
                            },
                            lj: 1,
                        },
                    ],
                    ip: 43,
                    op: 90,
                    st: -39,
                    td: 1,
                },
                {
                    ind: 14,
                    ty: 4,
                    nm: 's',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            k: [
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833,
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167,
                                    },
                                    t: 42,
                                    s: [885, 574, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    t: 70,
                                    s: [537, 370, 0],
                                },
                            ],
                            a: 1,
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [124.277, 124.277, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [28.142, 14.681],
                                                [2.471, 1.288],
                                                [2.471, 1.288],
                                                [2.54, 1.315],
                                                [2.406, 1.252],
                                                [2.471, 1.286],
                                                [2.471, 1.285],
                                                [2.472, 1.285],
                                                [2.472, 1.284],
                                                [2.472, 1.284],
                                                [2.473, 1.283],
                                                [2.473, 1.283],
                                                [2.473, 1.282],
                                                [2.474, 1.282],
                                                [2.474, 1.281],
                                                [2.474, 1.281],
                                                [2.475, 1.281],
                                                [2.474, 1.28],
                                                [2.475, 1.279],
                                                [2.475, 1.279],
                                                [2.475, 1.278],
                                                [2.476, 1.278],
                                                [2.476, 1.277],
                                                [2.477, 1.277],
                                                [2.477, 1.276],
                                                [2.477, 1.276],
                                                [2.478, 1.275],
                                                [2.478, 1.275],
                                                [2.479, 1.274],
                                                [2.479, 1.273],
                                                [2.479, 1.273],
                                                [2.48, 1.272],
                                                [2.48, 1.272],
                                                [2.48, 1.271],
                                                [2.481, 1.271],
                                                [2.481, 1.27],
                                                [2.481, 1.269],
                                                [2.482, 1.269],
                                                [2.482, 1.268],
                                                [2.482, 1.267],
                                                [2.483, 1.267],
                                                [14.737, 0],
                                                [0, -39.765],
                                                [-20.14, -12.764],
                                                [-2.353, -1.492],
                                                [-2.352, -1.492],
                                                [-2.352, -1.493],
                                                [-2.351, -1.494],
                                                [-2.351, -1.494],
                                                [-2.35, -1.495],
                                                [-2.35, -1.496],
                                                [-2.349, -1.496],
                                                [-2.349, -1.497],
                                                [-2.348, -1.497],
                                                [-2.348, -1.498],
                                                [-2.348, -1.499],
                                                [-2.347, -1.499],
                                                [-2.347, -1.5],
                                                [-2.346, -1.5],
                                                [-2.346, -1.501],
                                                [-2.346, -1.501],
                                                [-2.345, -1.502],
                                                [-2.345, -1.503],
                                                [-2.345, -1.503],
                                                [-2.344, -1.503],
                                                [-2.344, -1.504],
                                                [-2.343, -1.505],
                                                [-2.343, -1.505],
                                                [-2.343, -1.506],
                                                [-2.342, -1.506],
                                                [-2.342, -1.507],
                                                [-2.342, -1.507],
                                                [-2.341, -1.508],
                                                [-2.341, -1.508],
                                                [-2.34, -1.509],
                                                [-2.34, -1.509],
                                                [-2.34, -1.51],
                                                [-2.34, -1.51],
                                                [-2.339, -1.51],
                                                [-2.339, -1.511],
                                                [-2.28, -1.481],
                                                [-2.392, -1.547],
                                                [-2.336, -1.511],
                                                [-2.335, -1.512],
                                                [-20.603, 0],
                                                [0, 48.601],
                                            ],
                                            o: [
                                                [-2.326, -1.51],
                                                [-2.326, -1.51],
                                                [-2.386, -1.55],
                                                [-2.267, -1.465],
                                                [-2.323, -1.511],
                                                [-2.323, -1.512],
                                                [-2.323, -1.512],
                                                [-2.322, -1.513],
                                                [-2.322, -1.513],
                                                [-2.321, -1.514],
                                                [-2.321, -1.515],
                                                [-2.321, -1.515],
                                                [-2.32, -1.516],
                                                [-2.32, -1.516],
                                                [-2.319, -1.517],
                                                [-2.319, -1.518],
                                                [-2.318, -1.518],
                                                [-2.318, -1.519],
                                                [-2.318, -1.52],
                                                [-2.317, -1.52],
                                                [-2.317, -1.521],
                                                [-2.316, -1.522],
                                                [-2.316, -1.522],
                                                [-2.315, -1.523],
                                                [-2.315, -1.524],
                                                [-2.314, -1.524],
                                                [-2.314, -1.525],
                                                [-2.313, -1.526],
                                                [-2.313, -1.526],
                                                [-2.312, -1.527],
                                                [-2.312, -1.528],
                                                [-2.311, -1.529],
                                                [-2.311, -1.529],
                                                [-2.31, -1.53],
                                                [-2.31, -1.531],
                                                [-2.309, -1.531],
                                                [-2.309, -1.533],
                                                [-2.308, -1.533],
                                                [-2.307, -1.534],
                                                [-2.307, -1.535],
                                                [-11.411, -7.597],
                                                [-39.765, 0],
                                                [0, 25.608],
                                                [2.158, 1.745],
                                                [2.159, 1.745],
                                                [2.159, 1.744],
                                                [2.16, 1.743],
                                                [2.16, 1.743],
                                                [2.161, 1.742],
                                                [2.161, 1.741],
                                                [2.162, 1.741],
                                                [2.163, 1.74],
                                                [2.163, 1.739],
                                                [2.164, 1.739],
                                                [2.164, 1.738],
                                                [2.165, 1.737],
                                                [2.165, 1.737],
                                                [2.166, 1.736],
                                                [2.166, 1.736],
                                                [2.167, 1.735],
                                                [2.167, 1.734],
                                                [2.168, 1.734],
                                                [2.168, 1.733],
                                                [2.169, 1.732],
                                                [2.169, 1.732],
                                                [2.17, 1.731],
                                                [2.17, 1.731],
                                                [2.171, 1.73],
                                                [2.171, 1.73],
                                                [2.171, 1.729],
                                                [2.172, 1.729],
                                                [2.173, 1.728],
                                                [2.173, 1.727],
                                                [2.173, 1.727],
                                                [2.174, 1.726],
                                                [2.174, 1.726],
                                                [2.175, 1.726],
                                                [2.175, 1.725],
                                                [2.175, 1.724],
                                                [2.125, 1.683],
                                                [2.222, 1.768],
                                                [2.175, 1.721],
                                                [2.175, 1.721],
                                                [14.995, 11.86],
                                                [48.601, 0],
                                                [0, -33.939],
                                            ],
                                            v: [
                                                [176.142, 6.933],
                                                [168.944, 2.733],
                                                [161.745, -1.467],
                                                [154.353, -5.769],
                                                [147.343, -9.849],
                                                [140.148, -14.047],
                                                [132.954, -18.244],
                                                [125.76, -22.442],
                                                [118.565, -26.64],
                                                [111.371, -30.838],
                                                [104.176, -35.035],
                                                [96.982, -39.233],
                                                [89.787, -43.431],
                                                [82.593, -47.628],
                                                [75.399, -51.826],
                                                [68.205, -56.024],
                                                [61.01, -60.222],
                                                [53.816, -64.419],
                                                [46.621, -68.617],
                                                [39.427, -72.815],
                                                [32.233, -77.012],
                                                [25.038, -81.21],
                                                [17.844, -85.408],
                                                [10.649, -89.606],
                                                [3.455, -93.804],
                                                [-3.74, -98.001],
                                                [-10.934, -102.199],
                                                [-18.128, -106.397],
                                                [-25.323, -110.595],
                                                [-32.517, -114.792],
                                                [-39.711, -118.99],
                                                [-46.906, -123.188],
                                                [-54.1, -127.385],
                                                [-61.294, -131.583],
                                                [-68.489, -135.781],
                                                [-75.683, -139.979],
                                                [-82.877, -144.176],
                                                [-90.072, -148.374],
                                                [-97.266, -152.572],
                                                [-104.461, -156.769],
                                                [-111.655, -160.967],
                                                [-151.5, -173],
                                                [-223.5, -101],
                                                [-189.979, -40.158],
                                                [-183.205, -35.302],
                                                [-176.432, -30.447],
                                                [-169.658, -25.592],
                                                [-162.884, -20.737],
                                                [-156.11, -15.882],
                                                [-149.336, -11.027],
                                                [-142.562, -6.172],
                                                [-135.788, -1.317],
                                                [-129.014, 3.539],
                                                [-122.24, 8.394],
                                                [-115.466, 13.249],
                                                [-108.692, 18.104],
                                                [-101.919, 22.959],
                                                [-95.144, 27.814],
                                                [-88.371, 32.669],
                                                [-81.597, 37.524],
                                                [-74.823, 42.379],
                                                [-68.049, 47.235],
                                                [-61.275, 52.09],
                                                [-54.501, 56.945],
                                                [-47.727, 61.8],
                                                [-40.953, 66.655],
                                                [-34.179, 71.51],
                                                [-27.405, 76.366],
                                                [-20.631, 81.221],
                                                [-13.857, 86.076],
                                                [-7.084, 90.93],
                                                [-0.31, 95.786],
                                                [6.464, 100.641],
                                                [13.238, 105.496],
                                                [20.012, 110.351],
                                                [26.786, 115.206],
                                                [33.559, 120.061],
                                                [40.334, 124.917],
                                                [47.108, 129.772],
                                                [53.882, 134.627],
                                                [60.49, 139.376],
                                                [67.415, 144.353],
                                                [74.184, 149.205],
                                                [80.954, 154.057],
                                                [135.5, 173],
                                                [223.5, 85],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'gf',
                                    s: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 52,
                                                s: [-198.999, -170.129],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 63,
                                                s: [-369.094, -351.765],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    e: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 52,
                                                s: [178.631, 158.89],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 63,
                                                s: [-36.778, -44.585],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    t: 1,
                                    g: {
                                        k: {
                                            a: 0,
                                            k: [
                                                0, 1, 0.369, 0.192, 0.5, 0.904,
                                                0.684, 0.269, 1, 0.808, 1,
                                                0.345,
                                            ],
                                        },
                                        p: 3,
                                    },
                                    nm: 'G',
                                    bm: 0,
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                    ],
                    ip: 43,
                    op: 90,
                    st: 11,
                    tt: 1,
                },
                {
                    ind: 15,
                    ty: 4,
                    nm: 'm',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            a: 0,
                            k: [554.622, 539.93, 0],
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-4.195, -2.337],
                                                [0, 0],
                                                [-24.51, 39.427],
                                                [42.492, 24.512],
                                                [0, 0],
                                                [-4.495, -1.737],
                                                [0, 0],
                                                [-0.547, -0.189],
                                                [-7.162, 0],
                                                [-2.315, 30.747],
                                                [36.381, 0],
                                                [0, 0],
                                                [-0.394, -35.661],
                                                [-13.292, -11.581],
                                                [-16.07, -12.883],
                                                [3.656, 0],
                                                [0, 0],
                                                [0, -59.008],
                                                [-22.355, -19.6],
                                                [0, 0],
                                                [-37.22, 1.102],
                                                [-0.195, 68.745],
                                                [32.277, 23.374],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.805, -2.909],
                                                [0, 0],
                                                [40.516, 22.718],
                                                [25.859, -41.597],
                                                [0, 0],
                                                [-4.135, -2.428],
                                                [0, 0],
                                                [0, 0],
                                                [6.411, 2.215],
                                                [32.694, 0],
                                                [2.997, -39.795],
                                                [-17.828, 0],
                                                [-35.751, 0],
                                                [0.21, 18.97],
                                                [10.009, 8.721],
                                                [2.877, 2.306],
                                                [0, 0],
                                                [-59.065, 0],
                                                [0, 32.064],
                                                [0, 0],
                                                [24.095, 24.334],
                                                [68.775, -2.037],
                                                [0.121, -42.852],
                                                [0, 0],
                                            ],
                                            v: [
                                                [232.124, 113.596],
                                                [232.215, 113.596],
                                                [162.932, 58.397],
                                                [8.239, -60.662],
                                                [12.526, -67.107],
                                                [101.917, -17.062],
                                                [218.192, -46.907],
                                                [187.895, -167.795],
                                                [56.698, -243.61],
                                                [60.085, -250.594],
                                                [120.349, -226.472],
                                                [122.446, -225.691],
                                                [142.884, -222.247],
                                                [204.733, -278.853],
                                                [140.904, -346.46],
                                                [-137.698, -346.491],
                                                [-203.026, -281.581],
                                                [-181.001, -234.082],
                                                [-121.127, -185.475],
                                                [-123.554, -178.582],
                                                [-178.664, -178.582],
                                                [-285.346, -71.48],
                                                [-249.116, 8.592],
                                                [65.718, 307.693],
                                                [160.804, 345.66],
                                                [285.256, 217.85],
                                                [232.094, 113.627],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'fl',
                                    nm: 'F',
                                    bm: 0,
                                    c: {
                                        a: 0,
                                        k: [
                                            0.133333333333, 0.113725490196,
                                            0.098039215686, 1,
                                        ],
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                        {
                            ty: 'op',
                            nm: 'O',
                            ml: {
                                a: 0,
                                k: 4,
                            },
                            a: {
                                a: 0,
                                k: 0,
                            },
                            lj: 1,
                        },
                    ],
                    ip: 63,
                    op: 101,
                    st: -19,
                    td: 1,
                },
                {
                    ind: 16,
                    ty: 4,
                    nm: 's',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            k: [
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833,
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167,
                                    },
                                    t: 63,
                                    s: [295, 255, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    i: {
                                        x: 0.667,
                                        y: 0.667,
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167,
                                    },
                                    t: 83,
                                    s: [555, 257, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1,
                                    },
                                    o: {
                                        x: 1,
                                        y: 0,
                                    },
                                    t: 86,
                                    s: [555, 257, 0],
                                    ti: [0, 0, 0],
                                    to: [0, 0, 0],
                                },
                                {
                                    t: 101,
                                    s: [263, 257, 0],
                                },
                            ],
                            a: 1,
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [37.003, 0],
                                                [1.367, -0.083],
                                                [0.873, 0],
                                                [1.368, -0.083],
                                                [0.872, 0],
                                                [1.369, -0.083],
                                                [0.871, 0],
                                                [1.37, -0.083],
                                                [0.87, 0],
                                                [1.371, -0.083],
                                                [0.869, 0],
                                                [1.372, -0.083],
                                                [0.868, 0],
                                                [1.373, -0.083],
                                                [0.866, 0],
                                                [1.374, -0.083],
                                                [0.866, 0],
                                                [1.375, -0.083],
                                                [0.864, 0],
                                                [1.376, -0.083],
                                                [0.863, 0],
                                                [1.378, -0.083],
                                                [0.862, 0],
                                                [1.379, -0.083],
                                                [0.861, 0],
                                                [1.379, -0.083],
                                                [0.86, 0],
                                                [1.38, -0.083],
                                                [0.859, 0],
                                                [1.382, -0.083],
                                                [0.858, 0],
                                                [1.383, -0.083],
                                                [0.857, 0],
                                                [1.384, -0.083],
                                                [0.856, 0],
                                                [1.385, -0.083],
                                                [0.855, 0],
                                                [1.386, -0.083],
                                                [0.854, 0],
                                                [1.387, -0.083],
                                                [0.853, 0],
                                                [1.388, -0.083],
                                                [0.852, 0],
                                                [1.389, -0.083],
                                                [0.851, 0],
                                                [1.39, -0.083],
                                                [0.85, 0],
                                                [1.391, -0.083],
                                                [0.849, 0],
                                                [1.392, -0.083],
                                                [0.848, 0],
                                                [1.393, -0.083],
                                                [0.846, 0],
                                                [1.394, -0.083],
                                                [0.845, 0],
                                                [1.395, -0.083],
                                                [0.844, 0],
                                                [1.396, -0.083],
                                                [0.843, 0],
                                                [1.397, -0.083],
                                                [0.842, 0],
                                                [1.398, -0.082],
                                                [0.841, 0],
                                                [1.399, -0.083],
                                                [0.84, 0],
                                                [1.4, -0.082],
                                                [0.839, 0],
                                                [1.402, -0.082],
                                                [0.838, 0],
                                                [1.402, -0.082],
                                                [0.837, 0],
                                                [1.404, -0.082],
                                                [0.836, 0],
                                                [1.405, -0.082],
                                                [0.835, 0],
                                                [1.406, -0.082],
                                                [0.834, 0],
                                                [1.407, -0.082],
                                                [0.833, 0],
                                                [1.408, -0.082],
                                                [0.832, 0],
                                                [1.409, -0.082],
                                                [0.831, 0],
                                                [0, -39.765],
                                                [-39.765, 0],
                                                [-2.196, 0.202],
                                                [-0.022, 0],
                                                [-2.195, 0.202],
                                                [-0.023, 0],
                                                [-2.194, 0.202],
                                                [-0.025, 0],
                                                [-2.193, 0.202],
                                                [-0.025, 0],
                                                [-2.192, 0.202],
                                                [-0.027, 0],
                                                [-2.19, 0.202],
                                                [-0.028, 0],
                                                [-2.19, 0.203],
                                                [-0.029, 0],
                                                [-2.188, 0.203],
                                                [-0.03, 0],
                                                [-2.187, 0.203],
                                                [-0.031, 0],
                                                [-2.186, 0.203],
                                                [-0.032, 0],
                                                [-2.185, 0.203],
                                                [-0.033, 0],
                                                [-2.184, 0.203],
                                                [-0.034, 0],
                                                [-2.183, 0.203],
                                                [-0.035, 0],
                                                [-2.182, 0.204],
                                                [-0.036, 0],
                                                [-2.181, 0.204],
                                                [-0.037, 0],
                                                [-2.18, 0.204],
                                                [-0.038, 0],
                                                [-2.179, 0.204],
                                                [-0.039, 0],
                                                [-2.177, 0.204],
                                                [-0.04, 0],
                                                [-2.176, 0.204],
                                                [-0.041, 0],
                                                [-2.175, 0.205],
                                                [-0.042, 0],
                                                [-2.174, 0.205],
                                                [-0.043, 0],
                                                [-2.173, 0.205],
                                                [-0.044, 0],
                                                [-2.172, 0.205],
                                                [-0.045, 0],
                                                [-2.171, 0.205],
                                                [-0.047, 0],
                                                [-2.17, 0.205],
                                                [-0.048, 0],
                                                [-2.169, 0.206],
                                                [-0.049, 0],
                                                [-2.168, 0.206],
                                                [-0.05, 0],
                                                [-2.167, 0.206],
                                                [-0.051, 0],
                                                [-2.165, 0.206],
                                                [-0.052, 0],
                                                [-2.164, 0.206],
                                                [-0.053, 0],
                                                [-2.163, 0.206],
                                                [-0.054, 0],
                                                [-2.162, 0.207],
                                                [-0.055, 0],
                                                [-2.161, 0.207],
                                                [-0.056, 0],
                                                [-2.16, 0.207],
                                                [-0.057, 0],
                                                [-2.159, 0.207],
                                                [-0.058, 0],
                                                [-2.158, 0.207],
                                                [-0.059, 0],
                                                [-2.157, 0.207],
                                                [-0.06, 0],
                                                [-2.155, 0.208],
                                                [-0.062, 0],
                                                [-2.155, 0.208],
                                                [-0.062, 0],
                                                [-2.153, 0.208],
                                                [-0.063, 0],
                                                [-2.152, 0.208],
                                                [-0.065, 0],
                                                [0, 37.003],
                                            ],
                                            o: [
                                                [-1.388, 0],
                                                [-0.865, -0.033],
                                                [-1.389, 0],
                                                [-0.864, -0.033],
                                                [-1.39, 0],
                                                [-0.863, -0.033],
                                                [-1.391, 0],
                                                [-0.862, -0.033],
                                                [-1.392, 0],
                                                [-0.861, -0.032],
                                                [-1.393, 0],
                                                [-0.86, -0.032],
                                                [-1.394, 0],
                                                [-0.859, -0.032],
                                                [-1.395, 0],
                                                [-0.858, -0.032],
                                                [-1.396, 0],
                                                [-0.857, -0.032],
                                                [-1.397, 0],
                                                [-0.856, -0.032],
                                                [-1.398, 0],
                                                [-0.855, -0.032],
                                                [-1.399, 0],
                                                [-0.854, -0.032],
                                                [-1.4, 0],
                                                [-0.853, -0.031],
                                                [-1.401, 0],
                                                [-0.852, -0.031],
                                                [-1.402, 0],
                                                [-0.851, -0.031],
                                                [-1.404, 0],
                                                [-0.849, -0.031],
                                                [-1.405, 0],
                                                [-0.848, -0.031],
                                                [-1.405, 0],
                                                [-0.848, -0.031],
                                                [-1.407, 0],
                                                [-0.846, -0.031],
                                                [-1.407, 0],
                                                [-0.846, -0.031],
                                                [-1.409, 0],
                                                [-0.844, -0.03],
                                                [-1.41, 0],
                                                [-0.843, -0.03],
                                                [-1.411, 0],
                                                [-0.842, -0.03],
                                                [-1.412, 0],
                                                [-0.841, -0.03],
                                                [-1.413, 0],
                                                [-0.841, -0.03],
                                                [-1.414, 0],
                                                [-0.839, -0.03],
                                                [-1.415, 0],
                                                [-0.838, -0.03],
                                                [-1.416, 0],
                                                [-0.837, -0.029],
                                                [-1.417, 0],
                                                [-0.836, -0.029],
                                                [-1.418, 0],
                                                [-0.835, -0.029],
                                                [-1.419, 0],
                                                [-0.834, -0.029],
                                                [-1.42, 0],
                                                [-0.833, -0.029],
                                                [-1.421, 0],
                                                [-0.832, -0.029],
                                                [-1.422, 0],
                                                [-0.831, -0.029],
                                                [-1.423, 0],
                                                [-0.83, -0.029],
                                                [-1.424, 0],
                                                [-0.829, -0.029],
                                                [-1.425, 0],
                                                [-0.828, -0.028],
                                                [-1.426, 0],
                                                [-0.827, -0.028],
                                                [-1.427, 0],
                                                [-0.826, -0.028],
                                                [-1.428, 0],
                                                [-0.825, -0.028],
                                                [-1.43, 0],
                                                [-0.824, -0.028],
                                                [-39.765, 0],
                                                [0, 39.764],
                                                [2.249, 0],
                                                [0.022, 0],
                                                [2.248, 0],
                                                [0.023, 0],
                                                [2.246, 0],
                                                [0.025, 0],
                                                [2.246, 0],
                                                [0.025, 0],
                                                [2.244, 0],
                                                [0.027, 0],
                                                [2.243, 0],
                                                [0.028, 0],
                                                [2.242, 0],
                                                [0.029, 0],
                                                [2.241, 0],
                                                [0.03, 0],
                                                [2.24, 0],
                                                [0.031, 0],
                                                [2.239, 0],
                                                [0.032, 0],
                                                [2.238, 0],
                                                [0.033, 0],
                                                [2.237, 0],
                                                [0.034, 0],
                                                [2.236, 0],
                                                [0.035, 0],
                                                [2.235, 0],
                                                [0.036, 0],
                                                [2.234, 0],
                                                [0.037, 0],
                                                [2.233, 0],
                                                [0.038, 0],
                                                [2.232, 0],
                                                [0.039, 0],
                                                [2.231, 0],
                                                [0.04, 0],
                                                [2.23, 0],
                                                [0.041, 0],
                                                [2.229, 0],
                                                [0.042, 0],
                                                [2.228, 0],
                                                [0.043, 0],
                                                [2.227, 0],
                                                [0.044, 0],
                                                [2.226, 0],
                                                [0.045, 0],
                                                [2.224, 0],
                                                [0.047, 0],
                                                [2.224, 0],
                                                [0.048, 0],
                                                [2.222, 0],
                                                [0.049, 0],
                                                [2.222, 0],
                                                [0.05, 0],
                                                [2.22, 0],
                                                [0.051, 0],
                                                [2.219, 0],
                                                [0.052, 0],
                                                [2.218, 0],
                                                [0.053, 0],
                                                [2.217, 0],
                                                [0.054, 0],
                                                [2.216, 0],
                                                [0.055, 0],
                                                [2.215, 0],
                                                [0.056, 0],
                                                [2.214, 0],
                                                [0.057, 0],
                                                [2.213, 0],
                                                [0.058, 0],
                                                [2.212, 0],
                                                [0.059, 0],
                                                [2.211, 0],
                                                [0.06, 0],
                                                [2.21, 0],
                                                [0.062, 0],
                                                [2.209, 0],
                                                [0.062, 0],
                                                [2.208, 0],
                                                [0.063, 0],
                                                [2.207, 0],
                                                [0.065, 0],
                                                [37.003, 0],
                                                [0, -37.003],
                                            ],
                                            v: [
                                                [140.5, -73.5],
                                                [136.371, -73.361],
                                                [133.768, -73.427],
                                                [129.636, -73.288],
                                                [127.037, -73.354],
                                                [122.901, -73.215],
                                                [120.305, -73.281],
                                                [116.166, -73.142],
                                                [113.573, -73.207],
                                                [109.432, -73.069],
                                                [106.842, -73.134],
                                                [102.696, -72.996],
                                                [100.11, -73.061],
                                                [95.962, -72.922],
                                                [93.378, -72.988],
                                                [89.228, -72.849],
                                                [86.646, -72.915],
                                                [82.492, -72.776],
                                                [79.915, -72.841],
                                                [75.757, -72.703],
                                                [73.183, -72.768],
                                                [69.022, -72.63],
                                                [66.451, -72.695],
                                                [62.287, -72.557],
                                                [59.719, -72.622],
                                                [55.553, -72.484],
                                                [52.988, -72.549],
                                                [48.818, -72.411],
                                                [46.256, -72.476],
                                                [42.083, -72.338],
                                                [39.524, -72.402],
                                                [35.348, -72.265],
                                                [32.793, -72.329],
                                                [28.613, -72.192],
                                                [26.061, -72.256],
                                                [21.879, -72.118],
                                                [19.329, -72.183],
                                                [15.143, -72.045],
                                                [12.598, -72.11],
                                                [8.41, -71.972],
                                                [5.866, -72.037],
                                                [1.674, -71.899],
                                                [-0.866, -71.963],
                                                [-5.061, -71.826],
                                                [-7.598, -71.89],
                                                [-11.796, -71.753],
                                                [-14.329, -71.817],
                                                [-18.531, -71.68],
                                                [-21.061, -71.744],
                                                [-25.265, -71.607],
                                                [-27.793, -71.671],
                                                [-32.001, -71.534],
                                                [-34.524, -71.598],
                                                [-38.735, -71.461],
                                                [-41.256, -71.524],
                                                [-45.47, -71.388],
                                                [-47.988, -71.451],
                                                [-52.205, -71.314],
                                                [-54.719, -71.378],
                                                [-58.94, -71.241],
                                                [-61.451, -71.305],
                                                [-65.674, -71.168],
                                                [-68.183, -71.232],
                                                [-72.41, -71.095],
                                                [-74.915, -71.159],
                                                [-79.144, -71.022],
                                                [-81.646, -71.085],
                                                [-85.879, -70.949],
                                                [-88.378, -71.012],
                                                [-92.614, -70.876],
                                                [-95.11, -70.939],
                                                [-99.349, -70.803],
                                                [-101.841, -70.866],
                                                [-106.083, -70.73],
                                                [-108.573, -70.793],
                                                [-112.818, -70.657],
                                                [-115.305, -70.72],
                                                [-119.554, -70.584],
                                                [-122.037, -70.646],
                                                [-126.288, -70.51],
                                                [-128.768, -70.573],
                                                [-133.023, -70.437],
                                                [-135.5, -70.5],
                                                [-207.5, 1.5],
                                                [-135.5, 73.5],
                                                [-128.835, 73.181],
                                                [-128.768, 73.183],
                                                [-122.106, 72.864],
                                                [-122.037, 72.866],
                                                [-115.378, 72.547],
                                                [-115.305, 72.549],
                                                [-108.649, 72.23],
                                                [-108.573, 72.232],
                                                [-101.921, 71.913],
                                                [-101.841, 71.915],
                                                [-95.192, 71.595],
                                                [-95.11, 71.598],
                                                [-88.463, 71.278],
                                                [-88.378, 71.28],
                                                [-81.735, 70.961],
                                                [-81.646, 70.963],
                                                [-75.006, 70.644],
                                                [-74.915, 70.646],
                                                [-68.278, 70.327],
                                                [-68.183, 70.329],
                                                [-61.55, 70.01],
                                                [-61.451, 70.012],
                                                [-54.821, 69.693],
                                                [-54.719, 69.695],
                                                [-48.092, 69.375],
                                                [-47.988, 69.378],
                                                [-41.363, 69.058],
                                                [-41.256, 69.061],
                                                [-34.635, 68.741],
                                                [-34.524, 68.744],
                                                [-27.907, 68.424],
                                                [-27.793, 68.427],
                                                [-21.178, 68.107],
                                                [-21.061, 68.11],
                                                [-14.449, 67.79],
                                                [-14.329, 67.793],
                                                [-7.721, 67.472],
                                                [-7.598, 67.476],
                                                [-0.992, 67.155],
                                                [-0.866, 67.159],
                                                [5.736, 66.838],
                                                [5.866, 66.841],
                                                [12.465, 66.521],
                                                [12.598, 66.524],
                                                [19.194, 66.204],
                                                [19.329, 66.207],
                                                [25.922, 65.887],
                                                [26.061, 65.89],
                                                [32.65, 65.57],
                                                [32.793, 65.573],
                                                [39.379, 65.252],
                                                [39.524, 65.256],
                                                [46.108, 64.935],
                                                [46.256, 64.939],
                                                [52.836, 64.618],
                                                [52.988, 64.622],
                                                [59.565, 64.301],
                                                [59.719, 64.305],
                                                [66.293, 63.984],
                                                [66.451, 63.988],
                                                [73.022, 63.667],
                                                [73.183, 63.671],
                                                [79.75, 63.349],
                                                [79.915, 63.354],
                                                [86.479, 63.032],
                                                [86.646, 63.037],
                                                [93.208, 62.715],
                                                [93.378, 62.719],
                                                [99.936, 62.398],
                                                [100.11, 62.402],
                                                [106.665, 62.081],
                                                [106.842, 62.085],
                                                [113.393, 61.764],
                                                [113.573, 61.768],
                                                [120.121, 61.447],
                                                [120.305, 61.451],
                                                [126.851, 61.129],
                                                [127.037, 61.134],
                                                [133.579, 60.812],
                                                [133.768, 60.817],
                                                [140.307, 60.495],
                                                [140.5, 60.5],
                                                [207.5, -6.5],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'gf',
                                    s: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 63,
                                                s: [-610.99, 38.241],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 86,
                                                s: [-245.426, 12.484],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    e: {
                                        k: [
                                            {
                                                i: {
                                                    x: 0.833,
                                                    y: 0.833,
                                                },
                                                o: {
                                                    x: 0.167,
                                                    y: 0.167,
                                                },
                                                t: 63,
                                                s: [58.116, -8.969],
                                                ti: [0, 0],
                                                to: [0, 0],
                                            },
                                            {
                                                t: 86,
                                                s: [229.973, -4.282],
                                            },
                                        ],
                                        a: 1,
                                    },
                                    t: 1,
                                    g: {
                                        k: {
                                            a: 0,
                                            k: [
                                                0, 0.808, 1, 0.345, 0.5, 0.904,
                                                0.684, 0.269, 1, 1, 0.369,
                                                0.192,
                                            ],
                                        },
                                        p: 3,
                                    },
                                    nm: 'G',
                                    bm: 0,
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                    ],
                    ip: 63,
                    op: 101,
                    st: 58,
                    tt: 1,
                },
                {
                    ind: 17,
                    ty: 4,
                    nm: 'l',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                        },
                        r: {
                            a: 0,
                            k: 0,
                        },
                        p: {
                            a: 0,
                            k: [554.622, 539.93, 0],
                        },
                        a: {
                            a: 0,
                            k: [0, 0, 0],
                        },
                        s: {
                            a: 0,
                            k: [100, 100, 100],
                        },
                    },
                    shapes: [
                        {
                            ty: 'gr',
                            nm: 'G',
                            bm: 0,
                            it: [
                                {
                                    ty: 'sh',
                                    nm: 'P',
                                    ind: 0,
                                    ks: {
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-4.195, -2.337],
                                                [0, 0],
                                                [-24.51, 39.427],
                                                [42.492, 24.512],
                                                [0, 0],
                                                [-4.495, -1.737],
                                                [0, 0],
                                                [-0.547, -0.189],
                                                [-7.162, 0],
                                                [-2.315, 30.747],
                                                [36.381, 0],
                                                [0, 0],
                                                [-0.394, -35.661],
                                                [-13.292, -11.581],
                                                [-16.07, -12.883],
                                                [3.656, 0],
                                                [0, 0],
                                                [0, -59.008],
                                                [-22.355, -19.6],
                                                [0, 0],
                                                [-37.22, 1.102],
                                                [-0.195, 68.745],
                                                [32.277, 23.374],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.805, -2.909],
                                                [0, 0],
                                                [40.516, 22.718],
                                                [25.859, -41.597],
                                                [0, 0],
                                                [-4.135, -2.428],
                                                [0, 0],
                                                [0, 0],
                                                [6.411, 2.215],
                                                [32.694, 0],
                                                [2.997, -39.795],
                                                [-17.828, 0],
                                                [-35.751, 0],
                                                [0.21, 18.97],
                                                [10.009, 8.721],
                                                [2.877, 2.306],
                                                [0, 0],
                                                [-59.065, 0],
                                                [0, 32.064],
                                                [0, 0],
                                                [24.095, 24.334],
                                                [68.775, -2.037],
                                                [0.121, -42.852],
                                                [0, 0],
                                            ],
                                            v: [
                                                [232.124, 113.596],
                                                [231.215, 113.596],
                                                [161.932, 58.397],
                                                [7.239, -60.662],
                                                [12.526, -68.107],
                                                [101.917, -18.062],
                                                [217.192, -46.907],
                                                [187.895, -166.795],
                                                [56.698, -242.61],
                                                [60.085, -251.594],
                                                [120.349, -227.472],
                                                [122.446, -226.691],
                                                [142.884, -223.247],
                                                [204.733, -278.853],
                                                [140.904, -345.46],
                                                [-137.698, -345.491],
                                                [-202.026, -281.581],
                                                [-180.001, -234.082],
                                                [-120.127, -185.475],
                                                [-123.554, -177.582],
                                                [-178.664, -177.582],
                                                [-284.346, -71.48],
                                                [-246.116, 7.592],
                                                [65.718, 306.693],
                                                [160.804, 344.66],
                                                [284.256, 217.85],
                                                [232.094, 113.627],
                                            ],
                                            c: true,
                                        },
                                        a: 0,
                                    },
                                },
                                {
                                    ty: 'fl',
                                    nm: 'F',
                                    bm: 0,
                                    c: {
                                        a: 0,
                                        k: [
                                            0.133333333333, 0.113725490196,
                                            0.098039215686, 1,
                                        ],
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: 1,
                                },
                                {
                                    ty: 'tr',
                                    o: {
                                        a: 0,
                                        k: 100,
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                    },
                                    p: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    a: {
                                        a: 0,
                                        k: [0, 0],
                                    },
                                    s: {
                                        a: 0,
                                        k: [100, 100],
                                    },
                                    nm: 'T',
                                    sk: {
                                        a: 0,
                                        k: 0,
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                    },
                                },
                            ],
                        },
                        {
                            ty: 'op',
                            nm: 'O',
                            ml: {
                                a: 0,
                                k: 4,
                            },
                            a: {
                                a: 0,
                                k: 0,
                            },
                            lj: 1,
                        },
                    ],
                    ip: 1,
                    op: 83,
                    st: -19,
                },
            ],
        },
    ],
    layers: [
        {
            ind: 1,
            ty: 0,
            nm: 'E',
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                },
                r: {
                    a: 0,
                    k: 0,
                },
                p: {
                    a: 0,
                    k: [14.331, 0.105, 0],
                },
                a: {
                    a: 0,
                    k: [572, 540, 0],
                },
                s: {
                    a: 0,
                    k: [100.707, 100.707, 100],
                },
            },
            ip: 0,
            op: 100,
            st: -9,
            parent: 7,
            refId: 'comp_0',
            h: 1080,
            w: 1144,
        },
        {
            ind: 2,
            ty: 3,
            nm: 'N',
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 0,
                },
                r: {
                    a: 0,
                    k: 0,
                },
                p: {
                    a: 0,
                    k: [540, 540, 0],
                },
                a: {
                    a: 0,
                    k: [0, 0, 0],
                },
                s: {
                    a: 0,
                    k: [350, 350, 100],
                },
            },
            ip: 0,
            op: 138,
            st: 0,
        },
        {
            ind: 3,
            ty: 4,
            nm: 'V',
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                },
                r: {
                    a: 0,
                    k: 0,
                },
                p: {
                    a: 0,
                    k: [0, -1.28, 0],
                },
                a: {
                    a: 0,
                    k: [0, 0, 0],
                },
                s: {
                    a: 0,
                    k: [200, 200, 100],
                },
            },
            shapes: [
                {
                    ty: 'gr',
                    nm: 'G',
                    bm: 0,
                    it: [
                        {
                            ty: 'sh',
                            nm: 'P',
                            ind: 0,
                            ks: {
                                k: {
                                    i: [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                    ],
                                    o: [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                    ],
                                    v: [
                                        [-18.433, 2.22],
                                        [-7.624, 13.029],
                                        [18.433, -13.029],
                                    ],
                                    c: false,
                                },
                                a: 0,
                            },
                        },
                        {
                            ty: 'st',
                            nm: 'S',
                            bm: 0,
                            lc: 2,
                            lj: 2,
                            o: {
                                a: 0,
                                k: 100,
                            },
                            w: {
                                a: 0,
                                k: 4,
                            },
                            c: {
                                a: 0,
                                k: [
                                    0.960784316063, 0.960784316063,
                                    0.941176474094, 1,
                                ],
                            },
                        },
                        {
                            ty: 'tr',
                            o: {
                                a: 0,
                                k: 100,
                            },
                            r: {
                                a: 0,
                                k: 0,
                            },
                            p: {
                                a: 0,
                                k: [0, 0],
                            },
                            a: {
                                a: 0,
                                k: [0, 0],
                            },
                            s: {
                                a: 0,
                                k: [100, 100],
                            },
                            nm: 'T',
                            sk: {
                                a: 0,
                                k: 0,
                            },
                            sa: {
                                a: 0,
                                k: 0,
                            },
                        },
                    ],
                },
                {
                    ty: 'tm',
                    nm: 'T',
                    s: {
                        a: 0,
                        k: 0,
                    },
                    e: {
                        a: 1,
                        k: [
                            {
                                i: {
                                    x: [0.667],
                                    y: [1],
                                },
                                o: {
                                    x: [0.167],
                                    y: [0.167],
                                },
                                t: 108,
                                s: [0],
                            },
                            {
                                i: {
                                    x: [0.667],
                                    y: [1],
                                },
                                o: {
                                    x: [0.333],
                                    y: [0],
                                },
                                t: 114,
                                s: [29],
                            },
                            {
                                t: 122,
                                s: [100],
                            },
                        ],
                    },
                    o: {
                        a: 0,
                        k: 0,
                    },
                    m: 1,
                },
            ],
            ip: 0,
            op: 138,
            st: 0,
            parent: 2,
        },
        {
            ind: 4,
            ty: 4,
            nm: 'C',
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [0.833],
                                y: [0.833],
                            },
                            o: {
                                x: [0.167],
                                y: [0.167],
                            },
                            t: 135,
                            s: [100],
                        },
                        {
                            t: 137,
                            s: [0],
                        },
                    ],
                },
                r: {
                    a: 0,
                    k: 0,
                },
                p: {
                    k: [
                        {
                            i: {
                                x: 0.2,
                                y: 1,
                            },
                            o: {
                                x: 0.167,
                                y: 0.167,
                            },
                            t: 100,
                            s: [12, 33, 0],
                            ti: [-1, 18.167, 0],
                            to: [-9, -9.667, 0],
                        },
                        {
                            t: 118,
                            s: [0, -1, 0],
                        },
                    ],
                    a: 1,
                },
                a: {
                    a: 0,
                    k: [0, 0, 0],
                },
                s: {
                    k: [
                        {
                            i: {
                                x: [0.2, 0.2, 0.2],
                                y: [1, 1, 1],
                            },
                            o: {
                                x: [0.333, 0.333, 0.333],
                                y: [0, 0, 0],
                            },
                            t: 100,
                            s: [80, 80, 100],
                        },
                        {
                            t: 118,
                            s: [200, 200, 100],
                        },
                    ],
                    a: 1,
                },
            },
            shapes: [
                {
                    ty: 'gr',
                    nm: 'G',
                    bm: 0,
                    it: [
                        {
                            ty: 'sh',
                            nm: 'P',
                            ind: 0,
                            ks: {
                                k: {
                                    i: [
                                        [-26.51, 0],
                                        [0, -26.51],
                                        [26.51, 0],
                                        [0, 26.51],
                                    ],
                                    o: [
                                        [26.51, 0],
                                        [0, 26.51],
                                        [-26.51, 0],
                                        [0, -26.51],
                                    ],
                                    v: [
                                        [0, -48],
                                        [48, 0],
                                        [0, 48],
                                        [-48, 0],
                                    ],
                                    c: true,
                                },
                                a: 0,
                            },
                        },
                        {
                            ty: 'gf',
                            s: {
                                k: [
                                    {
                                        i: {
                                            x: 0.833,
                                            y: 0.833,
                                        },
                                        o: {
                                            x: 0.167,
                                            y: 0.167,
                                        },
                                        t: 113,
                                        s: [1.658, 33.575],
                                        ti: [0, 0],
                                        to: [0, 0],
                                    },
                                    {
                                        t: 120,
                                        s: [-1.384, -204.043],
                                    },
                                ],
                                a: 1,
                            },
                            e: {
                                k: [
                                    {
                                        i: {
                                            x: 0.833,
                                            y: 0.833,
                                        },
                                        o: {
                                            x: 0.167,
                                            y: 0.167,
                                        },
                                        t: 113,
                                        s: [-0.786, 131.309],
                                        ti: [0, 0],
                                        to: [0, 0],
                                    },
                                    {
                                        t: 120,
                                        s: [0.363, -64.691],
                                    },
                                ],
                                a: 1,
                            },
                            t: 1,
                            g: {
                                k: {
                                    a: 0,
                                    k: [
                                        0, 1, 0.757, 0.925, 0.5, 0.569, 0.439,
                                        0.516, 1, 0.137, 0.122, 0.106,
                                    ],
                                },
                                p: 3,
                            },
                            nm: 'G',
                            bm: 0,
                            o: {
                                a: 0,
                                k: 100,
                            },
                            r: 1,
                        },
                        {
                            ty: 'tr',
                            o: {
                                a: 0,
                                k: 100,
                            },
                            r: {
                                a: 0,
                                k: 0,
                            },
                            p: {
                                a: 0,
                                k: [0, 0],
                            },
                            a: {
                                a: 0,
                                k: [0, 0],
                            },
                            s: {
                                a: 0,
                                k: [100, 100],
                            },
                            nm: 'T',
                            sk: {
                                a: 0,
                                k: 0,
                            },
                            sa: {
                                a: 0,
                                k: 0,
                            },
                        },
                    ],
                },
            ],
            ip: 113,
            op: 138,
            st: -2,
            parent: 2,
        },
        {
            ind: 5,
            ty: 4,
            nm: 'C',
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                },
                r: {
                    a: 0,
                    k: 0,
                },
                p: {
                    k: [
                        {
                            i: {
                                x: 0.2,
                                y: 1,
                            },
                            o: {
                                x: 0.167,
                                y: 0.167,
                            },
                            t: 100,
                            s: [12, 33, 0],
                            ti: [-1, 18.167, 0],
                            to: [-9, -9.667, 0],
                        },
                        {
                            t: 118,
                            s: [0, -1, 0],
                        },
                    ],
                    a: 1,
                },
                a: {
                    a: 0,
                    k: [0, 0, 0],
                },
                s: {
                    k: [
                        {
                            i: {
                                x: [0.2, 0.2, 0.2],
                                y: [1, 1, 1],
                            },
                            o: {
                                x: [0.333, 0.333, 0.333],
                                y: [0, 0, 0],
                            },
                            t: 100,
                            s: [80, 80, 100],
                        },
                        {
                            t: 118,
                            s: [200, 200, 100],
                        },
                    ],
                    a: 1,
                },
            },
            shapes: [
                {
                    ty: 'gr',
                    nm: 'G',
                    bm: 0,
                    it: [
                        {
                            ty: 'sh',
                            nm: 'P',
                            ind: 0,
                            ks: {
                                k: {
                                    i: [
                                        [-26.51, 0],
                                        [0, -26.51],
                                        [26.51, 0],
                                        [0, 26.51],
                                    ],
                                    o: [
                                        [26.51, 0],
                                        [0, 26.51],
                                        [-26.51, 0],
                                        [0, -26.51],
                                    ],
                                    v: [
                                        [0, -48],
                                        [48, 0],
                                        [0, 48],
                                        [-48, 0],
                                    ],
                                    c: true,
                                },
                                a: 0,
                            },
                        },
                        {
                            ty: 'gf',
                            s: {
                                k: [
                                    {
                                        i: {
                                            x: 0.833,
                                            y: 0.833,
                                        },
                                        o: {
                                            x: 0.167,
                                            y: 0.167,
                                        },
                                        t: 109,
                                        s: [1.236, 45.361],
                                        ti: [0, 0],
                                        to: [0, 0],
                                    },
                                    {
                                        t: 113,
                                        s: [-1.805, -192.257],
                                    },
                                ],
                                a: 1,
                            },
                            e: {
                                k: [
                                    {
                                        i: {
                                            x: 0.833,
                                            y: 0.833,
                                        },
                                        o: {
                                            x: 0.167,
                                            y: 0.167,
                                        },
                                        t: 109,
                                        s: [-0.786, 131.309],
                                        ti: [0, 0],
                                        to: [0, 0],
                                    },
                                    {
                                        t: 113,
                                        s: [-0.568, -23.591],
                                    },
                                ],
                                a: 1,
                            },
                            t: 1,
                            g: {
                                k: {
                                    a: 0,
                                    k: [
                                        0.001, 0.808, 1, 0.345, 0.5, 0.904,
                                        0.878, 0.635, 1, 1, 0.757, 0.925,
                                    ],
                                },
                                p: 3,
                            },
                            nm: 'G',
                            bm: 0,
                            o: {
                                a: 0,
                                k: 100,
                            },
                            r: 1,
                        },
                        {
                            ty: 'tr',
                            o: {
                                a: 0,
                                k: 100,
                            },
                            r: {
                                a: 0,
                                k: 0,
                            },
                            p: {
                                a: 0,
                                k: [0, 0],
                            },
                            a: {
                                a: 0,
                                k: [0, 0],
                            },
                            s: {
                                a: 0,
                                k: [100, 100],
                            },
                            nm: 'T',
                            sk: {
                                a: 0,
                                k: 0,
                            },
                            sa: {
                                a: 0,
                                k: 0,
                            },
                        },
                    ],
                },
            ],
            ip: 109,
            op: 115,
            st: -2,
            parent: 2,
        },
        {
            ind: 6,
            ty: 4,
            nm: 'C',
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                },
                r: {
                    a: 0,
                    k: 0,
                },
                p: {
                    k: [
                        {
                            i: {
                                x: 0.2,
                                y: 1,
                            },
                            o: {
                                x: 0.167,
                                y: 0.167,
                            },
                            t: 100,
                            s: [12, 33, 0],
                            ti: [-1, 18.167, 0],
                            to: [-9, -9.667, 0],
                        },
                        {
                            t: 118,
                            s: [0, -1, 0],
                        },
                    ],
                    a: 1,
                },
                a: {
                    a: 0,
                    k: [0, 0, 0],
                },
                s: {
                    k: [
                        {
                            i: {
                                x: [0.2, 0.2, 0.2],
                                y: [1, 1, 1],
                            },
                            o: {
                                x: [0.333, 0.333, 0.333],
                                y: [0, 0, 0],
                            },
                            t: 100,
                            s: [80, 80, 100],
                        },
                        {
                            t: 118,
                            s: [200, 200, 100],
                        },
                    ],
                    a: 1,
                },
            },
            shapes: [
                {
                    ty: 'gr',
                    nm: 'G',
                    bm: 0,
                    it: [
                        {
                            ty: 'sh',
                            nm: 'P',
                            ind: 0,
                            ks: {
                                k: {
                                    i: [
                                        [-26.51, 0],
                                        [0, -26.51],
                                        [26.51, 0],
                                        [0, 26.51],
                                    ],
                                    o: [
                                        [26.51, 0],
                                        [0, 26.51],
                                        [-26.51, 0],
                                        [0, -26.51],
                                    ],
                                    v: [
                                        [0, -48],
                                        [48, 0],
                                        [0, 48],
                                        [-48, 0],
                                    ],
                                    c: true,
                                },
                                a: 0,
                            },
                        },
                        {
                            ty: 'gf',
                            s: {
                                k: [
                                    {
                                        i: {
                                            x: 0.833,
                                            y: 0.833,
                                        },
                                        o: {
                                            x: 0.167,
                                            y: 0.167,
                                        },
                                        t: 104,
                                        s: [1.236, 45.361],
                                        ti: [0, 0],
                                        to: [0, 0],
                                    },
                                    {
                                        t: 109,
                                        s: [-1.805, -192.257],
                                    },
                                ],
                                a: 1,
                            },
                            e: {
                                k: [
                                    {
                                        i: {
                                            x: 0.833,
                                            y: 0.833,
                                        },
                                        o: {
                                            x: 0.167,
                                            y: 0.167,
                                        },
                                        t: 104,
                                        s: [-0.786, 131.309],
                                        ti: [0, 0],
                                        to: [0, 0],
                                    },
                                    {
                                        t: 109,
                                        s: [-0.568, -23.591],
                                    },
                                ],
                                a: 1,
                            },
                            t: 1,
                            g: {
                                k: {
                                    a: 0,
                                    k: [
                                        0, 0.42, 0.522, 0.996, 0.5, 0.614,
                                        0.761, 0.671, 1, 0.808, 1, 0.345,
                                    ],
                                },
                                p: 3,
                            },
                            nm: 'G',
                            bm: 0,
                            o: {
                                a: 0,
                                k: 100,
                            },
                            r: 1,
                        },
                        {
                            ty: 'tr',
                            o: {
                                a: 0,
                                k: 100,
                            },
                            r: {
                                a: 0,
                                k: 0,
                            },
                            p: {
                                a: 0,
                                k: [0, 0],
                            },
                            a: {
                                a: 0,
                                k: [0, 0],
                            },
                            s: {
                                a: 0,
                                k: [100, 100],
                            },
                            nm: 'T',
                            sk: {
                                a: 0,
                                k: 0,
                            },
                            sa: {
                                a: 0,
                                k: 0,
                            },
                        },
                    ],
                },
            ],
            ip: 100,
            op: 109,
            st: -2,
            parent: 2,
        },
        {
            ind: 7,
            ty: 3,
            nm: 'L',
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 0,
                },
                r: {
                    a: 0,
                    k: 0,
                },
                p: {
                    k: [
                        {
                            i: {
                                x: 0,
                                y: 1,
                            },
                            o: {
                                x: 1,
                                y: 0,
                            },
                            t: 87,
                            s: [0, 17, 0],
                            ti: [0, 0, 0],
                            to: [0, 0, 0],
                        },
                        {
                            t: 117,
                            s: [0, -163, 0],
                        },
                    ],
                    a: 1,
                },
                a: {
                    a: 0,
                    k: [0, 0, 0],
                },
                s: {
                    a: 0,
                    k: [32, 32, 100],
                },
            },
            ip: 0,
            op: 138,
            st: -34,
            parent: 2,
        },
    ],
    markers: [
        {
            cm: '1',
            tm: 0,
            dr: 0,
        },
        {
            cm: '2',
            tm: 76,
            dr: 0,
        },
        {
            cm: '4',
            tm: 93,
            dr: 0,
        },
        {
            cm: '5',
            tm: 97,
            dr: 0,
        },
        {
            cm: '6',
            tm: 98,
            dr: 0,
        },
        {
            cm: '3',
            tm: 105,
            dr: 0,
        },
    ],
};

export default animationData;
